import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import { CircularProgressbar } from 'react-circular-progressbar';;
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Switch from 'react-switch';
import Modal from 'react-modal';
import ProfileCard from '../Subcomponents/ProfileCard';
import DecideOnCandidate from '../Common/DecideOnCandidate';
import SubCustomDropdown from '../Common/CustomDropdown';
import {convertDateToString} from '../Functions/ConvertDateToString';
import withRouter from '../Functions/WithRouter';

// const dropdownArrow = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/dropdown-arrow.png";
const arrowIndicatorIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/arrow-indicator-icon.png";
const deniedIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/denied-icon.png";
const addCircleOutlineIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/add-circle-outline-icon.png';

const videoIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/video-icon-dark.png';
const resumeIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/resume-icon-dark.png';
const linkedinIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/linkedin-icon-dark.png';
const websiteIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/website-icon-dark.png';
const coverLetterIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/cover-letter-icon-dark.png';
const letterOfRecIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/letter-of-rec-icon.png';
const transcriptIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/transcript-icon.png';
const idIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/identification-icon.png';
const editIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/edit-icon-dark.png';
const referIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/refer-icon-dark.png';
const emailIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/email-icon.png';
const reportingIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/reporting-icon-dark.png';
const profileIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/profile-icon-dark.png';
const closeIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png';

// let updateDetail = false

class AdminApplicationDetail extends Component {
  constructor(props) {
      super(props)
      this.state = {
          showModule: true,
          includeIconLabels: true,
          showLayoutToggle: false,

          selectedApplication: null,

          stage: '',
          notes: '',
          feedback: '',
          employerMessage: '',
          newApprovedTracks: [],
          wpQuestions: [],

          endorsements: [],

          benchmark: null,

          candidateType: '',
          trackOptions: [],
          scoreOptions: ['0','1','2','3','4','5'],
          filterOptions: ['','Highest Rating','Lowest Rating'],
          relationshipOptions: ['','Classmate','Mentor','Teacher'],
          pathwayOptions: [''],
          staffMemberOptions: [],
          stageOptions: [],

          trackSelected: '',
          interview: { interviewerName: '', date: '', score: ''},
          interviews: [],
          matchIndex: 0,
          eIndex: 0,

          notifyApproval: false,
          notifyOverallFeedback: false,

          customAssessment: null,
          showCustomAssessment: false,

          skillScores: '',
          interestResults: '',
          personalityResults: '',

          paidExperienceCount: 0,
          volunteerExperienceCount: 0,

          caRotation: 0,
          wpRotation: 0,

          applicationFormHasChanged: false,

          checklistErrorMessage: '',
          serverPostSuccess: true,
          serverSuccessMessage: '',
          serverErrorMessage: '',
      }

      this.retrieveData = this.retrieveData.bind(this)
      this.pullRemainingData = this.pullRemainingData.bind(this)
      this.renderQandA = this.renderQandA.bind(this)
      this.formChangeHandler = this.formChangeHandler.bind(this)
      this.saveApplication = this.saveApplication.bind(this)

      this.renderApprovals = this.renderApprovals.bind(this)
      this.renderInterviews = this.renderInterviews.bind(this)
      this.calculateInitialMatch = this.calculateInitialMatch.bind(this)
      this.calculateMatches = this.calculateMatches.bind(this)
      this.toggleView = this.toggleView.bind(this)
      this.removeTag = this.removeTag.bind(this)
      this.closeModal = this.closeModal.bind(this)

      this.addItem = this.addItem.bind(this)
      this.assign = this.assign.bind(this)
      this.configureValuesText = this.configureValuesText.bind(this)
      this.renderEditView = this.renderEditView.bind(this)
      this.actionClicked = this.actionClicked.bind(this)
      this.updateRank = this.updateRank.bind(this)
      this.exportInfo = this.exportInfo.bind(this)

      this.configureBenchmarkWeights = this.configureBenchmarkWeights.bind(this)
      this.renderAllocation = this.renderAllocation.bind(this)
      this.calculateBenchmarkWeight = this.calculateBenchmarkWeight.bind(this)
  }

  componentDidMount(){
    document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

    this.retrieveData()
  }

  componentWillUnmount() {
    console.log('componentWillUnmount called on detail')

    // updateDetail = true

  }

  componentDidUpdate(prevProps) {
    console.log('componentDidUpdate called ', this.props.activeOrg, prevProps)

    if (this.props.org !== prevProps.org || this.props.accountCode !== prevProps.accountCode || this.props.roleName !== prevProps.roleName) {
      this.retrieveData()
    } else if (this.props.selectedJob !== prevProps.selectedJob || this.props.applications !== prevProps.applications) {
      this.retrieveData()
    } else if (this.props.selectedApplication !== prevProps.selectedApplication && window.location.pathname.includes('/career-seekers')) {
      this.retrieveData()
    } else if (this.props.noBenchmark !== prevProps.noBenchmark) {
      this.retrieveData()
    }
  }

  retrieveData() {
    console.log('retrieveData called in adminAppDetail', this.props)

    // {console.log('goods: ', this.state.trackOptions, this.state.selectedApplication)}

    const accountCode = this.props.accountCode
    const org = this.props.org
    const id = this.props.id
    let selectedApplication = this.props.selectedApplication
    const candidateId = this.props.candidateId
    const benchmark = this.props.benchmark
    const noBenchmark = this.props.noBenchmark

    if (selectedApplication || candidateId) {

      if (this.props.calcImmediately) {
        // simply show profile

        const selectedJob = this.props.selectedJob
        const benchmarkOptions = this.props.benchmarkOptions

        this.calculateInitialMatch(selectedApplication, selectedJob, benchmark, benchmarkOptions, org, accountCode)

      } else {

        let appQueryObject = {}
        if (selectedApplication) {
          appQueryObject = { applicationId: selectedApplication._id }
        } else if (this.props.candidateId) {
          appQueryObject = { applicationId: this.props.candidateId }
        }

        Axios.get('/api/applications/byid', { params: appQueryObject })
        .then((response) => {
          console.log('Application by id query attempted', response.data);

          if (response.data.success) {
            console.log('application by id query worked', id)

            const newApplication = response.data.application

            if (!selectedApplication) {
              selectedApplication = response.data.application
            }

            //taking interview info because can't save skillScores
            selectedApplication['interview'] = newApplication.interview
            selectedApplication['interviewDetails'] = newApplication.interviewDetails

            selectedApplication['interviews'] = newApplication.interviews
            selectedApplication['interviewDetailsArray'] = newApplication.interviewDetailsArray

            selectedApplication['isSubsidyEligible'] = newApplication.isSubsidyEligible
            selectedApplication['isWorkforceReady'] = newApplication.isWorkforceReady
            selectedApplication['stage'] = newApplication.stage
            selectedApplication['notes'] = newApplication.notes
            selectedApplication['feedback'] = newApplication.feedback
            selectedApplication['rank'] = newApplication.rank

            let scorers = []
            if (newApplication.scorers) {
              scorers = newApplication.scorers
            }

            let assignedStaff = {}
            if (newApplication.assignedStaff) {
              assignedStaff = newApplication.assignedStaff
            }

            const workPreferenceResults = selectedApplication.workPreferenceResults
            this.setState({ scorers, assignedStaff, accountCode, benchmark, workPreferenceResults })

            if (newApplication.referralCode) {
              Axios.get('/api/referral/byid', { params: { _id: newApplication.referralCode } })
              .then((response) => {
                console.log('Referral query by id attempted', response.data);

                if (response.data.success) {
                  console.log('referral query worked')

                  let referralDetails = response.data.referral
                  this.setState({ referralDetails })

                } else {
                  console.log('referral query did not work', response.data.message)
                }

              }).catch((error) => {
                  console.log('Referral query did not work for some reason', error);
              });
            }

            Axios.get('/api/postings/byid', { params: { _id: id } })
            .then((response) => {
              console.log('posting by id query attempted', response.data);

              if (response.data.success) {
                console.log('posting by id query worked')

                const selectedJob = response.data.posting
                this.setState({ selectedJob })

                let orgCodes = [org, 'general']
                if (org === 'lausd') {
                  orgCodes.push('bixel')
                }

                if (selectedJob.placementPartners && selectedJob.placementPartners.includes(org)) {
                  console.log("this org doesn't own this posting")

                  if (selectedApplication.partnerEvaluations && selectedApplication.partnerEvaluations.some(pe => pe.orgCode === org)) {
                    console.log('got in')
                    const evalIndex = selectedApplication.partnerEvaluations.findIndex(pe => pe.orgCode === org);
                    selectedApplication['interview'] = selectedApplication.partnerEvaluations[evalIndex].interview
                    selectedApplication['notes'] = selectedApplication.partnerEvaluations[evalIndex].notes
                    selectedApplication['feedback'] = selectedApplication.partnerEvaluations[evalIndex].feedback
                    selectedApplication['isSubsidyEligible'] = selectedApplication.partnerEvaluations[evalIndex].isSubsidyEligible
                    selectedApplication['isWorkforceReady'] = selectedApplication.partnerEvaluations[evalIndex].isWorkforceReady

                  }

                  Axios.get('/api/benchmarks/byid', { params: { _id: selectedJob.benchmarkId } })
                  .then((response) => {
                    console.log('Benchmark query by id attempted', response.data);

                    if (response.data.success) {
                      console.log('benchmark query worked')

                      let benchmark = response.data.benchmark
                      const benchmarkOptions = []
                      // console.log('benchmark: ', benchmark.title)
                      // this.setState({ benchmarkOptions, benchmark, ogBenchmark })
                      this.calculateInitialMatch(selectedApplication, selectedJob, benchmark, benchmarkOptions, org, accountCode)

                    } else {
                      console.log('benchmark query did not work', response.data.message)
                      if (noBenchmark) {
                        this.setState({ noBenchmark })
                        this.pullRemainingData(selectedApplication, selectedJob, benchmark, [], org, accountCode)
                      }
                    }

                  }).catch((error) => {
                      console.log('Benchmark query did not work for some reason', error);

                  });

                } else {
                  console.log('gut check:', selectedApplication)

                  if (selectedJob.postType === 'Track' || selectedJob.subPostType === 'Track') {
                    Axios.get('/api/benchmarks', { params: { orgCodes } })
                    .then((response) => {
                      console.log('Benchmarks query attempted', response.data);

                      if (response.data.success) {
                        console.log('benchmark query worked while owning', selectedJob.benchmarkId)

                        if (response.data.benchmarks.length !== 0) {
                          console.log('there are benchmarks')
                          let benchmarkOptions = response.data.benchmarks

                          // let newBenchmarkOptions = []
                          // if (benchmarkOptions) {
                          //   for (let i = 1; i <= benchmarkOptions.length; i++) {
                          //     if (benchmarkOptions[i - 1].orgCode === org && !benchmarkOptions[i - 1].accountCode) {
                          //       newBenchmarkOptions.push(benchmarkOptions[i - 1])
                          //     }
                          //   }
                          // }
                          // benchmarkOptions = newBenchmarkOptions
                          console.log('list the benchmark options', benchmarkOptions)

                          benchmarkOptions.unshift({ title: 'No Benchmark Added'})

                          let benchmark = { title: 'No Benchmark Added' }

                          for (let i = 1; i <= response.data.benchmarks.length; i++) {
                            console.log(i);

                            if (response.data.benchmarks[i - 1]._id === selectedJob.benchmarkId) {

                              benchmark = response.data.benchmarks[i - 1]

                            }
                          }
                          console.log('selected benchmark: ', selectedJob.benchmarkId, benchmark)
                          // this.retrieveData(selectedApplication, selectedJob, benchmark, benchmarkOptions, org)
                          this.calculateInitialMatch(selectedApplication, selectedJob, benchmark, benchmarkOptions, org, accountCode)

                        }

                      } else {
                        console.log('benchmark query did not work', response.data.message)
                      }

                    }).catch((error) => {
                        console.log('Benchmark query did not work for some reason', error);
                    });
                  } else {
                    Axios.get('/api/benchmarks/byid', { params: { _id: selectedJob.benchmarkId } })
                    .then((response) => {
                      console.log('Benchmarks query attempted in adminAppDetail', response.data);

                      if (response.data.success) {
                        console.log('benchmark query worked')

                        let benchmark = response.data.benchmark
                        const benchmarkOptions = []

                        this.calculateInitialMatch(selectedApplication, selectedJob, benchmark, benchmarkOptions, org, accountCode)

                      } else {
                        console.log('benchmark query did not work', response.data.message)

                        if (noBenchmark) {
                          this.setState({ noBenchmark })
                          this.pullRemainingData(selectedApplication, selectedJob, benchmark, [], org, accountCode)
                        }
                      }

                    }).catch((error) => {
                        console.log('Benchmark query did not work for some reason', error);
                    });
                  }
                }

              } else {
                console.log('posting by id query did not work', response.data.message)
              }

            }).catch((error) => {
                console.log('Posting by post query did not work for some reason', error);
            });

          } else {
            console.log('Application by id query did not work', response.data.message)
          }

        }).catch((error) => {
            console.log('Application by post query did not work for some reason', error);
        });

        const roleNames = ['Admin']
        Axios.get('/api/org/members', { params: { orgCode: org, roleNames } })
        .then((response) => {
          if (response.data.success) {
            console.log('Member query worked', response.data);

            if (response.data.members && response.data.members.length > 0) {

              let staffMemberOptions = response.data.members
              if (staffMemberOptions) {
                staffMemberOptions.unshift({})
                this.setState({ staffMemberOptions })
              }
            }

          } else {
            console.log('no members found', response.data.message)
          }

        }).catch((error) => {
            console.log('Members query did not work', error);
        });
      }
    }
  }

  pullRemainingData(selectedApplication, selectedJob, benchmark, benchmarkOptions, org, accountCode) {
    console.log('pullRemainingData called ', selectedApplication, selectedJob)

    if (selectedApplication && selectedJob) {
      let email = localStorage.getItem('email');
      let username = localStorage.getItem('username');
      let cuFirstName = localStorage.getItem('firstName');
      let cuLastName = localStorage.getItem('lastName');
      let roleName = localStorage.getItem('roleName');

      let candidateType = ''
      if (selectedJob.title) {
        candidateType = selectedJob.title
      }

      let skillScores = ''
      let interestResults = ''
      let personalityResults = ''

      let feedback = ''
      if (selectedApplication.feedback) {
        feedback = selectedApplication.feedback
      }

      let isSubsidyEligible = false
      if (selectedApplication.isSubsidyEligible) {
        isSubsidyEligible = selectedApplication.isSubsidyEligible
      }

      let isWorkforceReady = false
      if (selectedApplication.isWorkforceReady) {
        isWorkforceReady = selectedApplication.isWorkforceReady
      }

      // console.log('let me see stage and notes', selectedApplication.stage, selectedApplication.notes)

      let stage = 'Applied'
      if (selectedApplication.stage) {
        stage = selectedApplication.stage
      }

      let notes = ''
      if (selectedApplication.notes) {
        notes = selectedApplication.notes
      }

      let employerMessage = ''
      if (selectedApplication.employerMessage) {
        employerMessage = selectedApplication.employerMessage
      }

      let trackOptions = []
      let interview = { interviewerName: '', date: '', score: ''}
      let interviews = []

      let totalHours = 0
      let experienceHours = 0
      let projectHours = 0
      let volunteerHours = 0
      let paidExperienceCount = 0
      let volunteerExperienceCount = 0

      if (selectedJob.postType === "Track" || selectedJob.subPostType === 'Track') {
        console.log('in tracks')
        trackOptions = selectedJob.tracks
        if (selectedApplication.interviews) {

          for (let i = 1; i <= selectedJob.tracks.length; i++) {
            if (selectedApplication.interviews[i - 1]) {
              const interviewerName = selectedApplication.interviews[i - 1].interviewerName
              const date = selectedApplication.interviews[i - 1].date
              const score = selectedApplication.interviews[i - 1].score
              interviews.push({interviewerName, date, score })
            } else {
              interviews.push({interviewerName: '', date: '', score: '0'})
            }
          }
          // interviews = selectedApplication.interviews
          // if (selectedApplication.interviews.length === selectedJob.tracks.length) {
          //   interviews = selectedApplication.interviews
          // } else {
          //   for (let i = 1; i <= selectedJob.tracks.length; i++) {
          //     interviews.push({interviewerName: '', date: '', score: '0'})
          //   }
          // }
        } else {
          for (let i = 1; i <= selectedJob.tracks.length; i++) {
            interviews.push({interviewerName: '', date: '', score: '0'})
          }
        }

      } else {

        if (selectedApplication.interview) {
          interview = selectedApplication.interview
        }

        if (selectedApplication.projects) {
          for (let i = 1; i <= selectedApplication.projects.length; i++) {
            console.log('see project ', selectedApplication.projects[i - 1].hours)
            const hourRange = selectedApplication.projects[i - 1].hours
            console.log('see project 1 ', hourRange.split(" - "))
            // const hourOptions = [{value: ''}, {value: '< 10'},{value: '10 - 50'}, {value: '50 - 100'}, {value: '100 - 500'}, {value: '500 - 1000'}, {value: '1000 - 5000'}, {value: '5000 - 10000'}, {value: '10000+'}]
            if (hourRange === '< 10') {
              projectHours = projectHours + 10
            } else if (hourRange === '10000+') {
              projectHours = projectHours + 10000
            } else {
              const hourArray = hourRange.split(" - ")
              const firstHour = Number(hourArray[0])
              const secondHour = Number(hourArray[1])
              const average = (firstHour + secondHour) / 2

              projectHours = projectHours + average
              totalHours = totalHours + average
            }
          }
        }

        if (selectedApplication.experience) {
          for (let i = 1; i <= selectedApplication.experience.length; i++) {

            const startDateString = selectedApplication.experience[i - 1].startDate
            const endDateString = selectedApplication.experience[i - 1].endDate
            const hoursPerWeek = selectedApplication.experience[i - 1].hoursPerWeek

            if (startDateString && endDateString && hoursPerWeek) {

              function convertMonth(longMonth) {
                console.log('convertMonth was called ', longMonth)

                let shortMonth = '01'
                if (longMonth === 'February') {
                  shortMonth = '02'
                } else if (longMonth === 'March') {
                  shortMonth = '03'
                } else if (longMonth === 'April') {
                  shortMonth = '04'
                } else if (longMonth === 'May') {
                  shortMonth = '05'
                } else if (longMonth === 'June') {
                  shortMonth = '06'
                } else if (longMonth === 'July') {
                  shortMonth = '07'
                } else if (longMonth === 'August') {
                  shortMonth = '08'
                } else if (longMonth === 'September') {
                  shortMonth = '09'
                } else if (longMonth === 'October') {
                  shortMonth = '10'
                } else if (longMonth === 'November') {
                  shortMonth = '11'
                } else if (longMonth === 'December') {
                  shortMonth = '12'
                }

                return shortMonth
              }

              const startDateArray = startDateString.split(" ")
              const startDateMonth = convertMonth(startDateArray[0])
              const startDate = new Date(startDateArray[1], startDateMonth, '01')

              const endDateArray = endDateString.split(" ")
              const endDateMonth = convertMonth(endDateArray[0])
              const endDate = new Date(endDateArray[1], endDateMonth, '01')

              const dateDifference = ((((endDate - startDate) / 1000) / 60) / 60) / 24

              console.log('show all date values: ', startDateString, startDateMonth, startDate, endDateString, endDateMonth, endDate, dateDifference, hoursPerWeek)

              const hoursPerWeekArray = hoursPerWeek.split(" ")
              const hpd = Number(hoursPerWeekArray[1]) / 7

              if (selectedApplication.experience[i - 1].wasPaid) {
                experienceHours = Math.round(experienceHours + (hpd * dateDifference))
                totalHours = Math.round(totalHours + (hpd * dateDifference))
                paidExperienceCount = paidExperienceCount + 1
              } else {
                volunteerHours = Math.round(volunteerHours + (hpd * dateDifference))
                totalHours = Math.round(totalHours + (hpd * dateDifference))
                volunteerExperienceCount = volunteerExperienceCount + 1
              }
            }
          }
        }

        console.log('show project and experience hours ', projectHours, experienceHours, totalHours )
      }

      this.setState({
        roleName,
        totalHours, projectHours, experienceHours, volunteerHours, paidExperienceCount, volunteerExperienceCount
      })

      if (selectedJob.placementPartners && selectedJob.placementPartners.includes(org)) {
        // console.log('dude is a pp 2')

        if (selectedApplication.partnerEvaluations && selectedApplication.partnerEvaluations.some(pe => pe.orgCode === org)) {

          const evalIndex = selectedApplication.partnerEvaluations.findIndex(pe => pe.orgCode === org);
          interview = selectedApplication.partnerEvaluations[evalIndex].interview
          notes = selectedApplication.partnerEvaluations[evalIndex].notes
          feedback = selectedApplication.partnerEvaluations[evalIndex].feedback
          isSubsidyEligible = selectedApplication.partnerEvaluations[evalIndex].isSubsidyEligible
          isWorkforceReady = selectedApplication.partnerEvaluations[evalIndex].isWorkforceReady
          // console.log('got in 2', notes, selectedApplication.partnerEvaluations[evalIndex].notes)
        }
      }

      if (email) {
        // console.log('orgy: ', org)
        Axios.get('/api/org', { params: { orgCode: org } })
        .then((response) => {
          console.log('Org info query attempted', response.data);

          if (response.data.success) {
            console.log('org info query worked')

            const orgName = response.data.orgInfo.orgName
            const orgURL = response.data.orgInfo.orgURL
            const orgMission = response.data.orgInfo.orgMission

            const orgContactFirstName = response.data.orgInfo.contactFirstName
            const orgContactLastName = response.data.orgInfo.contactLastName
            const orgContactEmail = response.data.orgInfo.contactEmail
            const orgContactTitle = response.data.orgInfo.contactTitle
            const orgProgramName = response.data.orgInfo.orgProgramName
            const onlyFeedback = response.data.orgInfo.onlyFeedback

            this.setState({

                org, orgName, orgURL, orgMission, orgProgramName,

                orgContactFirstName, orgContactLastName, orgContactTitle, orgContactEmail, onlyFeedback

            });

          } else {
            console.log('org info query did not work', response.data.message)
          }

        }).catch((error) => {
            console.log('Org info query did not work for some reason', error);
        });

        Axios.get('/api/assessment/questions')
        .then((response) => {
            //console.log('O*Net worked', response.data.body, this);
            console.log('show me response', response.data)
            if ( response.data.success === true ) {
              console.log('o-net query worked')

              let wpQuestions = []
              for (let i = 1; i <= response.data.assessments.workPreferenceQuestions.length; i++) {
                wpQuestions.push({ name: response.data.assessments.workPreferenceQuestions[i - 1].name })
              }

              this.setState({ wpQuestions })

            } else {
              console.log('Assessment question query failed', response.data.message)
            }


        }).catch((error) => {
            console.log('O*NET did not work', error);
        });

        Axios.get('/api/workoptions')
        .then((response) => {
          console.log('Work options query tried', response.data);

          if (response.data.success) {
            console.log('Work options query succeeded')

            let stageOptions = [''].concat(response.data.workOptions[0].applicationStageOptions)
            if (selectedJob.postType === 'Program') {
              stageOptions = [''].concat(response.data.workOptions[0].programStageOptions)
            }

            this.setState({
              pathwayOptions: response.data.workOptions[0].functionOptions, stageOptions
            })
          }
        }).catch((error) => {
            console.log('O*NET did not work', error);
        });

        let trackBenchmark = null
        if (selectedJob.tracks && selectedJob.tracks.length > 0) {
          for (let k = 1; k <= benchmarkOptions.length; k++) {

            if (selectedJob.tracks[0].benchmark._id === benchmarkOptions[k - 1]._id) {
              trackBenchmark = benchmarkOptions[k - 1]
            }
          }
        }

        let pathPrefix = '/organizations/' + org
        let sourceName = "Organization"
        if (window.location.pathname.includes('/employers')) {
          pathPrefix = '/employers/' + accountCode
          sourceName = "Employer"
        } else if (window.location.pathname.includes('/advisor')) {
          pathPrefix = '/advisor'
          sourceName = "Organization"
        }

        this.setState({
            emailId: email, username, cuFirstName, cuLastName, org, pathPrefix, sourceName,

            selectedJob, selectedApplication, benchmark,

            trackOptions, benchmarkOptions, trackBenchmark,

            stage, notes, interview, interviews, feedback, employerMessage,
            isSubsidyEligible, isWorkforceReady,

            candidateType, skillScores,
            interestResults, personalityResults,

        });
        console.log('b1')
        if (selectedJob.customAssessmentId) {
          console.log('b2')
          if (selectedJob.customAssessmentId !== '') {
            console.log('b3', selectedJob.customAssessmentId)
            Axios.get('/api/customassessments/byid', { params: { _id: selectedJob.customAssessmentId } })
            .then((response) => {
              console.log('Query custom assessment', response.data);

                if (response.data.success) {
                  console.log('successfully retrieved custom assessment')

                  this.setState({ customAssessment: response.data.assessment })

                } else {
                  console.log('no assessment data found', response.data.message)
                }

            }).catch((error) => {
                console.log('Assessment query did not work', error);
            });
          }
        } else if (selectedJob.isChild) {
          console.log('look at parent')

          // the questions should be included with the application
          let parentPostId = ''
          if (org === 'bixel') {
            parentPostId = '5c703cc7c29ab2400a036875'
          } else if (org === 'unite-la') {
            parentPostId = '5ee171c929bc432630ac7a95'
          }

          Axios.get('/api/postings/byid', { params: { _id: parentPostId } })
          .then((response) => {
            console.log('posting by id query attempted to get custom assessment', response.data);

            if (response.data.success) {
              console.log('posting by id query worked')

              const customAssessmentId = response.data.posting.customAssessmentId

              Axios.get('/api/customassessments/byid', { params: { _id: customAssessmentId } })
              .then((response) => {
                console.log('Query custom assessment', response.data);

                  if (response.data.success) {
                    console.log('successfully retrieved custom assessment')

                    this.setState({ customAssessment: response.data.assessment })

                  } else {
                    console.log('no assessment data found', response.data.message)
                  }

              }).catch((error) => {
                  console.log('Assessment query did not work', error);
              });

            } else {
              console.log('posting by id query did not work', response.data.message)
            }

          }).catch((error) => {
              console.log('Posting by post query did not work for some reason', error);
          });
        }
      }

      this.configureBenchmarkWeights(benchmark)
    }
  }

  calculateInitialMatch(application, selectedJob, benchmark, benchmarkOptions, activeOrg, accountCode) {
    console.log('calculateInitialMatch called in adminAppDetail ', application, selectedJob, benchmark, activeOrg, accountCode)

    if (selectedJob.postType === 'Track' || selectedJob.subPostType === 'Track') {
      console.log('show benchmarkOptions here: ', benchmarkOptions)

      Axios.post('/api/applications/matches', {
        application, selectedJob, benchmarkOptions, activeOrg })
      .then((response) => {
        console.log('application matches query attempted in SubAdminApplicationDetail')
        if (response.data.success) {

          this.setState({ application, benchmark, benchmarkOptions, animating: false });
          this.pullRemainingData(response.data.application, selectedJob, benchmark, benchmarkOptions, activeOrg, accountCode)

        } else {
          console.log('application matches did not work: ', response.data.message)
          this.setState({ serverPostSuccess: false, serverErrorMessage: 'there was an error retrieving applications ' + response.data.message, animating: false })

        }
      }).catch((error) => {
          console.log('Application matches did not work for some reason', error);
          this.setState({ serverPostSuccess: false, serverErrorMessage: 'there was an error retrieving applications ' + error, animating: false })
      });
    } else if (benchmark && (selectedJob.postType === 'Work' || selectedJob.postType === 'Individual' || selectedJob.subPostType === 'Individual' || selectedJob.subPostType === 'Internship' || selectedJob.subPostType === 'Apprenticeship' || selectedJob.subPostType === 'Part-Time' || selectedJob.subPostType === 'Full-Time' || selectedJob.postType === 'Program')) {

      Axios.post('/api/applications/matches', {
        application, selectedJob, benchmark, activeOrg })
      .then((response) => {
        console.log('application match query attempted')
        if (response.data.success) {
          //save values
          console.log('Application match save worked', response.data);

          let newApplication = response.data.application
          this.pullRemainingData(newApplication, selectedJob, benchmark, benchmarkOptions, activeOrg, accountCode)

        } else {
          console.log('application matches did not work', response.data.message)
        }
      }).catch((error) => {
          console.log('Application matches did not work for some reason', error);
      });
    // } else if (selectedJob.postType === 'Scholarship') {
    //
    //   Axios.post('/api/applications/matches', {
    //     application, selectedJob, benchmark, activeOrg })
    //   .then((response) => {
    //     console.log('application matches query attempted')
    //     if (response.data.success) {
    //       //save values
    //       console.log('Application matches save worked', response.data);
    //
    //       this.pullRemainingData(response.data.application, selectedJob, benchmark, benchmarkOptions, activeOrg)
    //
    //     } else {
    //       console.log('application matches did not work', response.data.message)
    //     }
    //   }).catch((error) => {
    //       console.log('Application matches did not work for some reason', error);
    //   });
    } else {
      console.log('we already calculated matches')
      this.setState({ application, benchmark, benchmarkOptions });
    }


  }

  calculateMatches(interviewIndex, interviewScore) {
    console.log('calculateMatches called', interviewIndex, interviewScore)

    let application = this.state.selectedApplication
    const selectedJob = this.state.selectedJob

    // Axios.get('/api/applications/matches', { params: { application, selectedJob, benchmark: this.state.benchmark, benchmarkOptions: this.state.benchmarkOptions } })
    // .then((response) => {
    //   console.log('Application matches', response.data);
    //
    //   if (response.data.success) {
    //     console.log('application matches query worked')
    //
    //     const selectedApplication = response.data.selectedApplication
    //
    //     this.setState({ selectedApplication });
    //
    //   } else {
    //     console.log('org info query did not work', response.data.message)
    //   }
    //
    // }).catch((error) => {
    //     console.log('Org info query did not work for some reason', error);
    // });

    let subPostType = selectedJob.postType
    if (selectedJob.subPostType) {
      subPostType = selectedJob.subPostType
    }
    // console.log('show subPostType: ', subPostType)
    const acceptableIndividualSubPostTypes = ['Internship','Individual','Apprenticeship','Full-Time','Part-Time','Volunteer','Scholarship']

    if (subPostType === 'Track' && interviewScore) {

      const benchmarkOptions = this.state.benchmarkOptions
      console.log('show payload: ', application, selectedJob, benchmarkOptions, interviewIndex, interviewScore )

      Axios.post('/api/applications/matches', {
        application, selectedJob, benchmarkOptions, interviewIndex, interviewScore, saveChanges: true })
      .then((response) => {
        console.log('application matches query attempted')
        if (response.data.success) {
          //save values
          console.log('Application matches save worked', response.data);

          const selectedApplication = response.data.application
          this.setState({ selectedApplication })

        } else {
          console.log('application matches did not work', response.data.message)
        }
      }).catch((error) => {
          console.log('Application matches did not work for some reason', error);
      });
    } else if (acceptableIndividualSubPostTypes.includes(subPostType) && interviewScore) {

      const benchmark = this.state.benchmark
      console.log('about to calculate individual matches', interviewScore)
      Axios.post('/api/applications/matches', {
        application, selectedJob, benchmark, interviewScore, saveChanges: true })
      .then((response) => {
        console.log('application matches query attempted')
        if (response.data.success) {
          //save values
          console.log('Application matches save worked', response.data);

          const selectedApplication = response.data.application
          this.setState({ selectedApplication })

        } else {
          console.log('application matches did not work', response.data.message)
        }
      }).catch((error) => {
          console.log('Application matches did not work for some reason', error);
      });
    } else {
      console.log('there was an error calculating matches')
      // this.setState({ applications, benchmark, benchmarkOptions });
    }

    // //pull questions from backend
    // const originalSkillQuestions = ["Adapting to new situations","Solving problems proactively","Being resilient in adversity","Working independently","Taking initiative and gathering resources (e.g. teammates, money) to solve a problem or reach a goal","Thinking critically","Analytical skills / sythesizing information","Actively listening","Reading","Writing","Speaking","Mathematics","Science","Being curious about unfamiliar things","Presentation skills","Being detail-Oriented","Being patient","Maintaining my integrity","Managing my time","Customer Service","Being flexible","Keeping myself accountable","Actively learning","Collaborating","Communicating","Being self-aware","Communicating in a non-english langauge","Empathizing","Leading others","Coordinating with others","Instructing others","Negotiating with others","Persuading others","Helping others proactively","Mentoring others, and vice versa","Teamwork with others","Being approachable","Being socially perceptive","How many hours best describes the time you have worked with spreadsheets (e.g. Microsoft Excel / Google Sheets)","Project Management","HTML and CSS","Javascript","Graphic / User Interface Design: creating enticing graphics / UI design for desired action or goal.","How many hours best describes the time you have spent learning and working on projects relevant to Software Development","Python","Java","Cloud Computing","PHP","SQL","Matlab","Perl","Go","iOS Development: Objective C or Swift","C or C++","C#","MongoDB, Cassandra, Couchbase, or HBase","Wordpress Development","Front-End Web Development","Back-End Web Development","Full-Stack Web Development","Android Mobile App Development","Game Development","Security Development","DevOps Engineer: making sure the development process goes smoothly for the development team through development tools","3rd Party APIs","How many hours best describes the time you have spent learning and working on projects relevant to Data Science","R","Hadoop, Hive, or Pig","Web Scraping","Machine Learning","How many hours best describes the time you have spent learning and working on projects relevant to Software Product Management","How many hours best describes the time you have spent learning and working on projects relevant to Digital Marketing","SEO / SEM","Analytics Software: for optimizing funnel / conversion rates","Copywriting","Video Creation: Engaging video content that leads to desired action / goals","Analytics Software: for optimizing funnel / conversion rates","Advertising: Managing paid content on advertising platforms (e.g. Google, Facebook) for desired action.","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Storytelling","How many hours best describes the time you have spent learning and working on projects relevant to UX / UI Design","Wireframing","User Research","Fundamental Design Principals","Prototyping Tools","Adobe Photoshop","Adobe Illustrator","How many hours best describes the time you have spent learning and working on projects relevant to customer service for a technology product or service","Troubleshooting","Business Process Improvement","Windows Server","Microsoft Exchange","Active Directory","Disaster Recovery","Network Administration","System Administration","Linux","VMWare","How many hours best describes the time you have spent learning and working on projects relevant to sales or recruiting.","Account Management Software","Creating Prospective Lists: researching and creating lists of clients with a high liklihood of conversion","Managing Prospective Lists: To maximize relationship and conversions with prospective clients","Closing deals: convincing qualified / interested clients to partner or pay for a service","Breaking down and meeting goals: Breaking down larger goals into smaller ones, and meeting those goals."]
    // console.log('please show plz', originalSkillQuestions.length, application.skillAnswers.length)
    //
    // const skillQuestions = ["Adaptability","Creative Problem Solving","Determination","Independent","Actively Learning","Thinking critically","Analytical / Research-Oriented","Active Listening","Reading","Writing","Speaking","Mathematics","Science","Curiosity","Presentation Skills","Detail-Oriented","Patience","Integrity","Time Management","Customer Service","Being flexible","Keeping myself accountable","Actively learning","Collaboration","Communication","Being self-aware","Communicating in a non-english langauge","Empathy","Leading others","Coordinating with others","Training and Development","Negotiating with others","Persuading Others","Helping others proactively","Mentoring others, and vice versa","Teamwork","Being approachable","Being socially perceptive","Google Suite / Office 365","Project Management","HTML and CSS","Javascript","Graphic Design","How many hours best describes the time you have spent learning and working on projects relevant to Software Development","Python","Java","Cloud Computing","PHP","SQL","Matlab","Perl","Go","iOS Development","C or C++","C#","MongoDB or Cassandra","Wordpress Development","Front-End Web Development","Back-End Web Development","Full-Stack Web Development","Android Development","Game Development","Security Development","DevOps Engineer: making sure the development process goes smoothly for the development team through development tools","3rd Party APIs","How many hours best describes the time you have spent learning and working on projects relevant to Data Science","R","Hadoop or Hive","Web Scraping","Machine Learning","How many hours best describes the time you have spent learning and working on projects relevant to Software Product Management","Marketing Strategy","SEO and SEM","Analytics Software","Copywriting","Video Creation: Engaging video content that leads to desired action / goals","Analytics Software: for optimizing funnel / conversion rates","Advertising","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Messaging (e.g. Email, Push, Social Media) to prospective or current customers","Storytelling","How many hours best describes the time you have spent learning and working on projects relevant to UX / UI Design","Wireframing","User Research","Fundamental Design Principals","Prototyping Tools","Adobe Photoshop","Adobe Illustrator","How many hours best describes the time you have spent learning and working on projects relevant to customer service for a technology product or service","Troubleshooting","Business Process Improvement","Windows Server","Microsoft Exchange","Active Directory","Disaster Recovery","Network Administration","System Administration","Linux","VMWare","How many hours best describes the time you have spent learning and working on projects relevant to sales or recruiting.","Account Management Software","Creating Prospective Lists","Managing Prospective Lists","Closing deals: convincing qualified / interested clients to partner or pay for a service","Reaching Stretch Goals"]
    //
    // if (this.state.selectedJob.postType !== 'Track') {
    //
    //   let selectedBenchmark = this.state.benchmark
    //
    //   let totalScore = 0
    //
    //   let interestsWeight = 0
    //   let interestsDifferential = 0
    //   let includeInterestsValue = 0
    //   if (application.interestResults.length !== 0) {
    //     includeInterestsValue = 1
    //
    //     //interests
    //     interestsWeight = Number(selectedBenchmark.interests[0].weight) + Number(selectedBenchmark.interests[1].weight) + Number(selectedBenchmark.interests[2].weight) + Number(selectedBenchmark.interests[3].weight) + Number(selectedBenchmark.interests[4].weight) + Number(selectedBenchmark.interests[5].weight)
    //
    //     let realisticScore1 = (application.interestResults[0].score / 40) * 100
    //     let realisticScore2 = selectedBenchmark.interests[0].score * 20
    //     let realisticDifferential = Math.abs(realisticScore1 - realisticScore2)
    //     let wRealistic = (realisticDifferential * (selectedBenchmark.interests[0].weight / interestsWeight))
    //
    //     let investigativeScore1 = (application.interestResults[1].score / 40) * 100
    //     let investigativeScore2 = selectedBenchmark.interests[1].score * 20
    //     let investigativeDifferential = Math.abs(investigativeScore1 - investigativeScore2)
    //     let wInvestigative = (investigativeDifferential * (selectedBenchmark.interests[1].weight / interestsWeight))
    //
    //     let artisticScore1 = (application.interestResults[2].score / 40) * 100
    //     let artisticScore2 = selectedBenchmark.interests[2].score * 20
    //     let artisticDifferential = Math.abs(artisticScore1 - artisticScore2)
    //     let wArtistic = (artisticDifferential * (selectedBenchmark.interests[2].weight / interestsWeight))
    //
    //     let socialScore1 = (application.interestResults[3].score / 40) * 100
    //     let socialScore2 = selectedBenchmark.interests[3].score * 20
    //     let socialDifferential = Math.abs(socialScore1 - socialScore2)
    //     let wSocial = (socialDifferential * (selectedBenchmark.interests[3].weight / interestsWeight))
    //
    //     let enterprisingScore1 = (application.interestResults[4].score / 40) * 100
    //     let enterprisingScore2 = selectedBenchmark.interests[4].score * 20
    //     let enterprisingDifferential = Math.abs(enterprisingScore1 - enterprisingScore2)
    //     let wEnterprising = (enterprisingDifferential * (selectedBenchmark.interests[4].weight / interestsWeight))
    //
    //     let conventionalScore1 = (application.interestResults[5].score / 40) * 100
    //     let conventionalScore2 = selectedBenchmark.interests[5].score * 20
    //     let conventionalDifferential = Math.abs(conventionalScore1 - conventionalScore2)
    //     let wConventional = (conventionalDifferential * (selectedBenchmark.interests[5].weight / interestsWeight))
    //
    //     interestsDifferential =  wRealistic + wInvestigative + wArtistic + wSocial + wEnterprising + wConventional
    //
    //   }
    //
    //   let skillsWeight = 0
    //   let skillsDifferential = 0
    //   let includeSkillsValue = 0
    //
    //   if (application.skillAnswers.length !== 0) {
    //     includeSkillsValue = 1
    //
    //     let skillAnswers = application.skillAnswers
    //
    //     let totalDifferential = 0
    //     for (let k = 1; k <= selectedBenchmark.skills.length; k++) {
    //
    //
    //       skillsWeight = skillsWeight + Number(selectedBenchmark.skills[k - 1].weight)
    //
    //       if (skillQuestions.includes(selectedBenchmark.skills[k - 1].title)) {
    //
    //         let questionIndex = skillQuestions.indexOf(selectedBenchmark.skills[k - 1].title)
    //
    //         let skillScore1 = Number(skillAnswers[questionIndex]) * 20
    //         let skillScore2 = selectedBenchmark.skills[k - 1].score * 20
    //         let skillDifferential = Math.abs(skillScore1 - skillScore2)
    //         totalDifferential = totalDifferential + skillDifferential
    //
    //       }
    //     }
    //
    //     //cant figure out how to do weight so we devide evently for now
    //     skillsDifferential = totalDifferential / selectedBenchmark.skills.length
    //
    //
    //   }
    //
    //   let traitsWeight = 0
    //   let traitsDifferential = 0
    //   let includeTraitsValue = 0
    //   if (application.personalityResults.length !== 0) {
    //     includeTraitsValue = 1
    //
    //     //traits
    //     traitsWeight = Number(selectedBenchmark.traits[0].weight) + Number(selectedBenchmark.traits[1].weight) + Number(selectedBenchmark.traits[2].weight) + Number(selectedBenchmark.traits[3].weight) + Number(selectedBenchmark.traits[4].weight)
    //
    //     let opennessScore1 = (application.personalityResults.fiveFactors.opennessScore / 16) * 100
    //     let opennessScore2 = selectedBenchmark.traits[0].score * 20
    //     let opennessDifferential = Math.abs(opennessScore1 - opennessScore2)
    //     let wOpenness = (opennessDifferential * (selectedBenchmark.traits[0].weight / traitsWeight))
    //
    //     let conscientiousnessScore1 = (application.personalityResults.fiveFactors.conscientiousnessScore / 16) * 100
    //     let conscientiousnessScore2 = selectedBenchmark.traits[1].score * 20
    //     let conscientiousnessDifferential = Math.abs(conscientiousnessScore1 - conscientiousnessScore2)
    //     let wConscientiousness = (conscientiousnessDifferential * (selectedBenchmark.traits[1].weight / traitsWeight))
    //
    //     let extraversionScore1 = (application.personalityResults.fiveFactors.extraversionScore / 16) * 100
    //     let extraversionScore2 = selectedBenchmark.traits[2].score * 20
    //     let extraversionDifferential = Math.abs(extraversionScore1 - extraversionScore2)
    //     let wExtraversion = (extraversionDifferential * (selectedBenchmark.traits[2].weight / traitsWeight))
    //
    //     let agreeablenessScore1 = (application.personalityResults.fiveFactors.agreeablenessScore / 16) * 100
    //     let agreeablenessScore2 = selectedBenchmark.traits[3].score * 20
    //     let agreeablenessDifferential = Math.abs(agreeablenessScore1 - agreeablenessScore2)
    //     let wAgreeableness = (agreeablenessDifferential * (selectedBenchmark.traits[3].weight / traitsWeight))
    //
    //     let neuroticismScore1 = (application.personalityResults.fiveFactors.neuroticismScore / 16) * 100
    //     let neuroticismScore2 = selectedBenchmark.traits[4].score * 20
    //     let neuroticismDifferential = Math.abs(neuroticismScore1 - neuroticismScore2)
    //     let wNeuroticism = (neuroticismDifferential * (selectedBenchmark.traits[4].weight / traitsWeight))
    //
    //     traitsDifferential =  wOpenness + wConscientiousness + wExtraversion + wAgreeableness + wNeuroticism
    //
    //     console.log('gimme traits', opennessDifferential, wOpenness, traitsWeight, traitsDifferential)
    //
    //   }
    //
    //
    //   let interviewWeight = 0
    //   let interviewDifferential = 0
    //   let includeInterviewValue = 0
    //
    //   if (selectedBenchmark.interview) {
    //     interviewWeight = selectedBenchmark.interview.weight
    //     includeInterviewValue = 1
    //     interviewDifferential = (5 - Number(interviewScore)) * 20
    //   }
    //
    //   let combinedWeight = interestsWeight + skillsWeight + traitsWeight + interviewWeight
    //   let wInterests = includeInterestsValue * (interestsDifferential  * (interestsWeight / combinedWeight ))
    //   let wSkills = includeSkillsValue * (skillsDifferential * (skillsWeight / combinedWeight ))
    //   let wTraits = includeTraitsValue * (traitsDifferential * (traitsWeight / combinedWeight ))
    //   let wInterview = includeInterviewValue * (interviewDifferential * (interviewWeight / combinedWeight))
    //
    //   let finalDifferential = wInterests + wSkills + wTraits + wInterview
    //   console.log('lets see final values', interestsDifferential, interestsWeight, wInterests, traitsDifferential, traitsWeight, wTraits, skillsDifferential, skillsWeight, wSkills,interviewDifferential, interviewWeight, wInterview, finalDifferential)
    //   console.log('what is finalDifferential again', Math.round(finalDifferential))
    //   console.log('lets see interview values', wInterview, includeInterviewValue, interviewDifferential, interviewWeight)
    //
    //   application["match"] = 100 - Math.round(finalDifferential)
    //
    // } else {
    //   //track
    //   console.log('plz', this.state.selectedJob.tracks)
    //   for (let j = 1; j <= this.state.selectedJob.tracks.length; j++) {
    //
    //     let selectedBenchmark = null
    //     for (let k = 1; k <= this.state.benchmarkOptions.length; k++) {
    //
    //       if (this.state.selectedJob.tracks[j - 1].benchmark._id === this.state.benchmarkOptions[k - 1]._id) {
    //         selectedBenchmark = this.state.benchmarkOptions[k - 1]
    //       }
    //     }
    //
    //     console.log('lets see selectedBenchmark', selectedBenchmark)
    //
    //     let totalScore = 0
    //
    //     let interestsWeight = 0
    //     let interestsDifferential = 0
    //     let includeInterestsValue = 0
    //     if (application.interestResults.length !== 0) {
    //       includeInterestsValue = 1
    //
    //       //interests
    //       interestsWeight = Number(selectedBenchmark.interests[0].weight) + Number(selectedBenchmark.interests[1].weight) + Number(selectedBenchmark.interests[2].weight) + Number(selectedBenchmark.interests[3].weight) + Number(selectedBenchmark.interests[4].weight) + Number(selectedBenchmark.interests[5].weight)
    //
    //       let realisticScore1 = (application.interestResults[0].score / 40) * 100
    //       let realisticScore2 = selectedBenchmark.interests[0].score * 20
    //       let realisticDifferential = Math.abs(realisticScore1 - realisticScore2)
    //       let wRealistic = (realisticDifferential * (selectedBenchmark.interests[0].weight / interestsWeight))
    //
    //       let investigativeScore1 = (application.interestResults[1].score / 40) * 100
    //       let investigativeScore2 = selectedBenchmark.interests[1].score * 20
    //       let investigativeDifferential = Math.abs(investigativeScore1 - investigativeScore2)
    //       let wInvestigative = (investigativeDifferential * (selectedBenchmark.interests[1].weight / interestsWeight))
    //
    //       let artisticScore1 = (application.interestResults[2].score / 40) * 100
    //       let artisticScore2 = selectedBenchmark.interests[2].score * 20
    //       let artisticDifferential = Math.abs(artisticScore1 - artisticScore2)
    //       let wArtistic = (artisticDifferential * (selectedBenchmark.interests[2].weight / interestsWeight))
    //
    //       let socialScore1 = (application.interestResults[3].score / 40) * 100
    //       let socialScore2 = selectedBenchmark.interests[3].score * 20
    //       let socialDifferential = Math.abs(socialScore1 - socialScore2)
    //       let wSocial = (socialDifferential * (selectedBenchmark.interests[3].weight / interestsWeight))
    //
    //       let enterprisingScore1 = (application.interestResults[4].score / 40) * 100
    //       let enterprisingScore2 = selectedBenchmark.interests[4].score * 20
    //       let enterprisingDifferential = Math.abs(enterprisingScore1 - enterprisingScore2)
    //       let wEnterprising = (enterprisingDifferential * (selectedBenchmark.interests[4].weight / interestsWeight))
    //
    //       let conventionalScore1 = (application.interestResults[5].score / 40) * 100
    //       let conventionalScore2 = selectedBenchmark.interests[5].score * 20
    //       let conventionalDifferential = Math.abs(conventionalScore1 - conventionalScore2)
    //       let wConventional = (conventionalDifferential * (selectedBenchmark.interests[5].weight / interestsWeight))
    //
    //       interestsDifferential =  wRealistic + wInvestigative + wArtistic + wSocial + wEnterprising + wConventional
    //
    //     }
    //
    //     let skillsWeight = 0
    //     let skillsDifferential = 0
    //     let includeSkillsValue = 0
    //
    //     if (application.skillAnswers.length !== 0) {
    //       includeSkillsValue = 1
    //
    //       let skillAnswers = application.skillAnswers
    //
    //       let totalDifferential = 0
    //       for (let k = 1; k <= selectedBenchmark.skills.length; k++) {
    //
    //
    //         skillsWeight = skillsWeight + Number(selectedBenchmark.skills[k - 1].weight)
    //
    //         if (skillQuestions.includes(selectedBenchmark.skills[k - 1].title)) {
    //           console.log('we got the title',selectedBenchmark.skills[k - 1].title)
    //           let questionIndex = skillQuestions.indexOf(selectedBenchmark.skills[k - 1].title)
    //
    //           let skillScore1 = Number(skillAnswers[questionIndex]) * 20
    //           let skillScore2 = selectedBenchmark.skills[k - 1].score * 20
    //           let skillDifferential = Math.abs(skillScore1 - skillScore2)
    //           totalDifferential = totalDifferential + skillDifferential
    //
    //         }
    //       }
    //
    //       if (j === 1) {
    //         console.log('show me benchmark skillz', this.state.selectedApplication.postingTitle, selectedBenchmark.skills.length, skillsWeight)
    //       }
    //
    //       //cant figure out how to do weight so we devide evently for now
    //       skillsDifferential = totalDifferential / selectedBenchmark.skills.length
    //
    //     }
    //
    //     let traitsWeight = 0
    //     let traitsDifferential = 0
    //     let includeTraitsValue = 0
    //     if (application.personalityResults.length !== 0) {
    //       includeTraitsValue = 1
    //
    //       //traits
    //       traitsWeight = Number(selectedBenchmark.traits[0].weight) + Number(selectedBenchmark.traits[1].weight) + Number(selectedBenchmark.traits[2].weight) + Number(selectedBenchmark.traits[3].weight) + Number(selectedBenchmark.traits[4].weight)
    //
    //       let opennessScore1 = (application.personalityResults.fiveFactors.opennessScore / 16) * 100
    //       let opennessScore2 = selectedBenchmark.traits[0].score * 20
    //       let opennessDifferential = Math.abs(opennessScore1 - opennessScore2)
    //       let wOpenness = (opennessDifferential * (selectedBenchmark.traits[0].weight / traitsWeight))
    //
    //       let conscientiousnessScore1 = (application.personalityResults.fiveFactors.conscientiousnessScore / 16) * 100
    //       let conscientiousnessScore2 = selectedBenchmark.traits[1].score * 20
    //       let conscientiousnessDifferential = Math.abs(conscientiousnessScore1 - conscientiousnessScore2)
    //       let wConscientiousness = (conscientiousnessDifferential * (selectedBenchmark.traits[1].weight / traitsWeight))
    //
    //       let extraversionScore1 = (application.personalityResults.fiveFactors.extraversionScore / 16) * 100
    //       let extraversionScore2 = selectedBenchmark.traits[2].score * 20
    //       let extraversionDifferential = Math.abs(extraversionScore1 - extraversionScore2)
    //       let wExtraversion = (extraversionDifferential * (selectedBenchmark.traits[2].weight / traitsWeight))
    //
    //       let agreeablenessScore1 = (application.personalityResults.fiveFactors.agreeablenessScore / 16) * 100
    //       let agreeablenessScore2 = selectedBenchmark.traits[3].score * 20
    //       let agreeablenessDifferential = Math.abs(agreeablenessScore1 - agreeablenessScore2)
    //       let wAgreeableness = (agreeablenessDifferential * (selectedBenchmark.traits[3].weight / traitsWeight))
    //
    //       let neuroticismScore1 = (application.personalityResults.fiveFactors.neuroticismScore / 16) * 100
    //       let neuroticismScore2 = selectedBenchmark.traits[4].score * 20
    //       let neuroticismDifferential = Math.abs(neuroticismScore1 - neuroticismScore2)
    //       let wNeuroticism = (neuroticismDifferential * (selectedBenchmark.traits[4].weight / traitsWeight))
    //
    //       traitsDifferential =  wOpenness + wConscientiousness + wExtraversion + wAgreeableness + wNeuroticism
    //
    //       console.log('gimme traits', opennessDifferential, wOpenness, traitsWeight, traitsDifferential)
    //
    //     }
    //
    //
    //     let interviewWeight = 0
    //     let interviewDifferential = 0
    //     let includeInterviewValue = 0
    //
    //     if (selectedBenchmark.interview) {
    //       interviewWeight = selectedBenchmark.interview.weight
    //       includeInterviewValue = 1
    //       interviewDifferential = 5 * 20
    //
    //       //interview
    //       let testIndex = j - 1
    //       if (testIndex === interviewIndex) {
    //         console.log('went in testIndex')
    //
    //         interviewDifferential = (5 - Number(interviewScore)) * 20
    //       } else {
    //
    //         interviewDifferential = (5 - Number(this.state.interviews[j - 1].score)) * 20
    //       }
    //     }
    //
    //     let combinedWeight = interestsWeight + skillsWeight + traitsWeight + interviewWeight
    //     let wInterests = includeInterestsValue * (interestsDifferential  * (interestsWeight / combinedWeight ))
    //     let wSkills = includeSkillsValue * (skillsDifferential * (skillsWeight / combinedWeight ))
    //     let wTraits = includeTraitsValue * (traitsDifferential * (traitsWeight / combinedWeight ))
    //     let wInterview = includeInterviewValue * (interviewDifferential * (interviewWeight / combinedWeight))
    //
    //     let finalDifferential = wInterests + wSkills + wTraits + wInterview
    //     console.log('lets see final values', j, interestsDifferential, interestsWeight, wInterests, traitsDifferential, traitsWeight, wTraits, skillsDifferential, skillsWeight, wSkills,interviewDifferential, interviewWeight, wInterview, finalDifferential)
    //     console.log('what is finalDifferential again', Math.round(finalDifferential))
    //     console.log('lets see interview values', wInterview, includeInterviewValue, interviewDifferential, interviewWeight)
    //
    //     if (application["matches"]) {
    //       let matches = application["matches"]
    //       matches[j - 1] = 100 - Math.round(finalDifferential)
    //       application["matches"] = matches
    //     }
    //   }
    // }
    //
    // console.log('lets see applications', application)
    // this.setState({ selectedApplication: application });

  }

  closeModal() {
    this.setState({ modalIsOpen: false, showEditView: false, showAssignStaff: false,
      showAssignScorers: false, showMatchScore: false
    });
  }

  formChangeHandler(event) {
    console.log('formChangeHandler called')

    if (event.target.name === 'notes') {
      this.setState({ notes: event.target.value, applicationFormHasChanged: true })
    } else if (event.target.name === 'employerMessage') {
      this.setState({ employerMessage: event.target.value, applicationFormHasChanged: true })
    } else if (event.target.name.includes('interview')) {

      if (this.state.selectedJob.postType === 'Track' || this.state.selectedJob.subPostType === 'Track') {
        let nameArray = event.target.name.split("|")

        let nameIndex = Number(nameArray[2]) - 1
        let interviews = this.state.interviews
        if (nameArray[1] === 'name') {
          interviews[nameIndex] = {
            interviewerName: event.target.value,
            date: interviews[nameIndex].date,
            score: interviews[nameIndex].score
          }
        } else if (nameArray[1] === 'date') {

          interviews[nameIndex] = {
            interviewerName: interviews[nameIndex].interviewerName,
            date: event.target.value,
            score: interviews[nameIndex].score
          }
        } else if (nameArray[1] === 'score') {
          // console.log('show indvalues: ', interviews, nameIndex)
          interviews[nameIndex] = {
            interviewerName: interviews[nameIndex].interviewerName,
            date: interviews[nameIndex].date,
            score: event.target.value
          }
          this.calculateMatches(nameIndex, event.target.value)
        }
        this.setState({ interviews, applicationFormHasChanged: true })
      } else {
        let nameArray = event.target.name.split("|")

        let interview = this.state.interview
        if (nameArray[1] === 'name') {
          interview = {
            interviewerName: event.target.value,
            date: interview.date,
            score: interview.score
          }
        } else if (nameArray[1] === 'date') {

          interview = {
            interviewerName: interview.interviewerName,
            date: event.target.value,
            score: interview.score
          }
        } else if (nameArray[1] === 'score') {
          interview = {
            interviewerName: interview.interviewerName,
            date: interview.date,
            score: event.target.value
          }

          let nameIndex = 0
          this.calculateMatches(nameIndex, event.target.value)
        }
        this.setState({ interview, applicationFormHasChanged: true })
      }

    } else if (event.target.name === 'feedback') {

      let notifyOverallFeedback = this.state.notifyOverallFeedback
      if (event.target.value === '') {
        notifyOverallFeedback = false
      } else {
        notifyOverallFeedback = true
      }
      this.setState({ feedback: event.target.value, notifyOverallFeedback, applicationFormHasChanged: true })

    } else if (event.target.name === 'track') {

      let trackSelected = event.target.value
      let matchIndex = 0
      for (let i = 1; i <= this.state.trackOptions.length; i++) {
        console.log(i);
        if (trackSelected === this.state.trackOptions[i - 1].name) {
          matchIndex = i - 1
        }
      }

      let trackBenchmark = null
      for (let k = 1; k <= this.state.benchmarkOptions.length; k++) {

        if (this.state.selectedJob.tracks[matchIndex].benchmark._id === this.state.benchmarkOptions[k - 1]._id) {
          trackBenchmark = this.state.benchmarkOptions[k - 1]
        }
      }

      this.setState({ trackSelected, matchIndex, trackBenchmark })
    } else if (event.target.name === 'staffMember') {
      let assignedStaff = this.state.assignedStaff
      for (let i = 1; i <= this.state.staffMemberOptions.length; i++) {
        const fullName = this.state.staffMemberOptions[i - 1].firstName + ' ' + this.state.staffMemberOptions[i - 1].lastName
        if (fullName === event.target.value) {
          assignedStaff = this.state.staffMemberOptions[i - 1]
        }
      }
      this.setState({ assignedStaff })
    } else if (event.target.name === 'scorerEmail') {
      this.setState({ scorerEmail: event.target.value })
    } else if (event.target.name === 'scorerFirstName') {
      this.setState({ scorerFirstName: event.target.value })
    } else if (event.target.name === 'scorerLastName') {
      this.setState({ scorerLastName: event.target.value })
    } else if (event.target.name === 'scorerJobTitle') {
      this.setState({ scorerJobTitle: event.target.value })
    } else if (event.target.name === 'scorerEmployerName') {
      this.setState({ scorerEmployerName: event.target.value })
    } else {
      this.setState({ stage: event.target.value, applicationFormHasChanged: true })
    }
  }

  saveApplication() {
    console.log('saveApplication called', this.state.isWorkforceReady)

    this.setState({
      serverSuccessMessage: '',
      serverErrorMessage: ''
    })

    if (!this.state.applicationFormHasChanged) {
      console.log('mic check 1')
      this.setState({ serverPostSuccess: false, serverErrorMessage: 'Make changes to form before saving'})
    }

    if (this.state.applicationFormHasChanged) {
      console.log('mic check 3')
      const _id = this.state.selectedApplication._id
      const stage = this.state.stage
      const notes = this.state.notes
      const employerMessage = this.state.employerMessage
      const updatedAt = new Date()
      console.log('let me see stage and notes', stage, notes)

      const interview = this.state.interview
      const interviews = this.state.interviews
      const feedback = this.state.feedback
      const isSubsidyEligible = this.state.isSubsidyEligible
      const isWorkforceReady = this.state.isWorkforceReady

      const email = this.state.selectedApplication.email
      const postingEmployerName = this.state.selectedApplication.postingEmployerName
      const firstName = this.state.selectedApplication.firstName
      const lastName = this.state.selectedApplication.lastName

      //notifications
      const notifyApproval = this.state.notifyApproval
      const newApprovedTracks = this.state.newApprovedTracks
      const notifyOverallFeedback = this.state.notifyOverallFeedback

      let matches = []
      if (this.state.selectedApplication.matches) {
        matches = this.state.selectedApplication.matches
      }

      let match = 0
      if (this.state.selectedApplication.match) {
        match = this.state.selectedApplication.match
      }

      const orgName = this.state.orgName
      const orgContactFirstName = this.state.orgContactFirstName
      const orgContactLastName = this.state.orgContactLastName
      const orgContactEmail = this.state.orgContactEmail
      const orgContactTitle = this.state.orgContactTitle
      const orgProgramName = this.state.orgProgramName
      let isPlacementPartner = false
      if (this.state.selectedJob.placementPartners && this.state.selectedJob.placementPartners.includes(this.state.org)) {
        isPlacementPartner = true
      }

      const evaluatorOrgCode = this.state.org

      Axios.post('/api/applications/update-by-id', { //sessions: sessions
        _id, stage, notes, employerMessage, interview,
        interviews, feedback, isSubsidyEligible, isWorkforceReady, matches, match,
        notifyApproval, newApprovedTracks, notifyOverallFeedback,
        email, orgName, orgContactEmail, postingEmployerName, firstName, lastName,
        orgContactFirstName, orgContactLastName, orgContactTitle, orgProgramName, isPlacementPartner, evaluatorOrgCode,
        updatedAt })
      .then((response) => {

        if (response.data.success) {
          //save values
          console.log('Application save worked', response.data);
          this.setState({
            serverPostSuccess: true,
            serverSuccessMessage: 'Application updated successfully!'
          })

        } else {
          console.error('there was an error updating the application');
          this.setState({
            serverPostSuccess: false,
            serverErrorMessage: response.data.message,
          })
        }
      }).catch((error) => {
          console.log('Application save did not work', error);
      });
    }
  }

  renderApprovals() {
    console.log('renderApprovals called', this.state.selectedJob.tracks)

    let selectedJob = this.state.selectedJob
    let rows = []

    if (this.state.selectedApplication && this.state.selectedApplication.matches) {

      for (let i = 1; i <= selectedJob.tracks.length; i++) {

        let index = i - 1

        let isApproved = false
        if (selectedJob.tracks[i - 1].approvedApplicants) {
          console.log('compare the two: ', selectedJob.tracks[i - 1].approvedApplicants, this.state.selectedApplication.email)
          if (selectedJob.tracks[i - 1].approvedApplicants.includes(this.state.selectedApplication.email)) {
            isApproved = true
          }
        }

        const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primaryColor');
        // console.log('show matchScore -----: ', matchScore, primaryColor)

        rows.push(
          <div key={i.toString + "approval"}>
            <div className={(window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) ? "relative-column-33 center-text padding-10" : "relative-column-25 center-text padding-10"}>
              <div className="spacer" /><div className="spacer" />
              <div key="match" className="width-80 center-item">
                <CircularProgressbar
                  value={this.state.selectedApplication.matches[i - 1]}
                  text={`${this.state.selectedApplication.matches[i - 1]}%`}
                  styles={{
                    path: { stroke: `${primaryColor}, ${this.state.selectedApplication.matches[i - 1] / 100}` },
                    text: { fill: primaryColor, fontSize: '24px' },
                    trail: { stroke: 'transparent' }
                  }}
                />
              </div>

              <label className="row-10 center-text">{selectedJob.tracks[i - 1].name}</label>

              <div className="clear" />

              {(window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) && (
                <div className="row-10">
                  <Switch
                    onChange={(change) => this.changeApproval(index, change)}
                    checked={isApproved}
                    id="normal-switch"
                  />
                </div>
              )}
            </div>

            {(window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) ? (
              <div>
                {(index % 3 === 2) && (
                  <div className="clear" />
                )}
              </div>
            ) : (
              <div>
                {(index % 4 === 3) && (
                  <div className="clear" />
                )}
              </div>
            )}

          </div>
        )
      }
    }

    return rows
  }

  changeApproval(index, change) {
    console.log('changeApproval called', index, change)

    const _id = this.state.selectedJob._id
    const emailId = this.state.selectedApplication.email
    let newApprovedTracks  = this.state.newApprovedTracks
    let selectedJob = this.state.selectedJob

    Axios.post('/api/postings/approve-applicant', { _id, emailId, index, change, newApprovedTracks })
    .then((response) => {

      if (response.data.success) {
        //save values
        console.log('Applicant approval save worked', response.data);

        const serverPostSuccess = true
        const serverSuccessMessage = response.data.message
        const applicationFormHasChanged = true

        const notifyApproval = response.data.notifyApproval
        newApprovedTracks = response.data.newApprovedTracks
        const approvedApplicants = response.data.approvedApplicants
        selectedJob['tracks'][index]['approvedApplicants'] = approvedApplicants

        this.setState({ serverPostSuccess, serverSuccessMessage, notifyApproval, applicationFormHasChanged,
          newApprovedTracks, selectedJob
        })

      } else {
        console.error('there was an error saving the edits to applicants approved');
        this.setState({
          serverPostSuccess: false,
          serverErrorMessage: response.data.message,
        })
      }
    }).catch((error) => {
        console.log('The applicant approval save did not work', error);
    });

  }

  renderInterviews() {
    console.log('renderInterviews called', this.state.interviews)

    let rows = []

    for (let i = 1; i <= this.state.selectedJob.tracks.length; i++) {

      const trackIndex = i - 1

      let nameName = "interview|name|" + i
      let dateName = "interview|date|" + i
      let scoreName = "interview|score|" + i

      let interviewerName = ''
      let interviewDate = ''

      let interviewScore = ''
      if (this.state.interviews[i - 1]) {
        if (this.state.interviews[i - 1].interviewerName) {
          interviewerName = this.state.interviews[i - 1].interviewerName
        }
        if (this.state.interviews[i - 1].date) {
          interviewDate = this.state.interviews[i - 1].date
        }
        if (this.state.interviews[i - 1].score) {
          interviewScore = this.state.interviews[i - 1].score
        }
      }

      rows.push(
        <div key={i}>
          <p className="profile-descriptor half-bold-text">#{i} {this.state.selectedJob.tracks[i - 1].name}</p>
          <div className="relative-column-60">
            <p className="profile-descriptor">Interviewer Name</p>
            <input type="text" className="text-field" placeholder="Add the name..." name={nameName} value={interviewerName} onChange={this.formChangeHandler}></input>
          </div>
          <div className="relative-column-20">
            <p className="profile-descriptor">Interview Date</p>
            <input type="date" className="date-field half-bold-text" placeholder="Add a date..." name={dateName} value={interviewDate} onChange={this.formChangeHandler}></input>
          </div>
          <div className="relative-column-20">
            <p className="profile-descriptor">Interview Score</p>
            <select name={scoreName} value={interviewScore} onChange={this.formChangeHandler} className="dropdown">
              {this.state.scoreOptions.map(value =>
                <option key={value.key} value={value}>{value}</option>
              )}
            </select>
          </div>
          <div className="clear"/>

          <div className="row-10 float-right">
            <Link className="secret-link" to={this.state.pathPrefix + '/postings/' + this.state.selectedApplication._id + '/applications/' + this.state.selectedApplication._id + '/interview'} state={{ selectedApplication: this.state.selectedApplication, selectedTrack: this.state.selectedJob.tracks[trackIndex], interview: this.state.interviews[trackIndex], selectedJob: this.state.selectedJob, trackIndex }}>
              <div className="float-right horizontal-padding-7">
                <div className="half-spacer" /><div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" />
                <img src={arrowIndicatorIcon} alt="GC" className="image-auto-12"/>
              </div>
              <div className="float-right horizontal-padding-7">
                <label className="description-text-2 description-text-color half-bold-text">Edit Details</label>
                <div className="half-spacer" />
              </div>
            </Link>
          </div>
          <div className="clear"/>
          <div className="half-spacer" />
        </div>
      )
    }

    return rows
  }

  renderQandA(source) {
    console.log('renderQandA called', source)

    let rows = []

    if (source === 'ca') {
      if (this.state.selectedApplication && this.state.selectedApplication.newCustomAssessmentResults && this.state.selectedApplication.newCustomAssessmentResults.length > 0) {
        console.log('in newCustomAssessmentResults', )
        if (this.state.showCustomAssessment) {
          console.log('testing 1')
          for (let i = 1; i <= this.state.selectedApplication.newCustomAssessmentResults.length; i++) {
            console.log('count custom assessment resullts', i, this.state.selectedApplication.newCustomAssessmentResults[i - 1])

            if (this.state.selectedApplication.newCustomAssessmentResults[i - 1]) {
              rows.push(
                <div key={i.toString() + "customAssessment"}>
                  <div className="row-5 horizontal-padding-9">
                      <label className="profile-descriptor">{this.state.selectedApplication.newCustomAssessmentResults[i - 1].question}</label>
                      <p className="row-10">{this.state.selectedApplication.newCustomAssessmentResults[i - 1].answer}</p>
                  </div>
                </div>
              )
            }
          }
        }
      } else if (this.state.selectedApplication && this.state.selectedApplication.customAssessmentResults) {
        if (this.state.customAssessment) {
          let questions = this.state.customAssessment.questions
          let results = this.state.selectedApplication.customAssessmentResults

          let loopLength = 0
          if (questions <= results) {
            loopLength = questions.length
          } else {
            loopLength = results.length
          }
          console.log('show length: ', questions.length, results.length)

          if (this.state.showCustomAssessment) {
            console.log('testing 1')
            for (let i = 1; i <= loopLength; i++) {
              console.log('count custom assessment resullts', i)

              if (questions[i - 1]) {
                rows.push(
                  <div key={i.toString() + "customAssessment"}>
                    <div className="row-5 horizontal-padding-9">
                        <label className="profile-descriptor">{questions[i - 1].name}</label>
                        <p className="row-10">{results[i - 1]}</p>
                    </div>
                  </div>
                )
              }
            }
          }
        }
      }
    } else if (source === 'wp') {

      let questions = this.state.wpQuestions
      let results = this.state.selectedApplication.workPreferenceResults
      // if (this.state.workPreferenceResults) {
      //   results = this.state.workPreferenceResults
      // }
      // console.log('show results: ', this.state.selectedApplication)
      let loopLength = 0
      if (questions <= results) {
        loopLength = questions.length
      } else {
        loopLength = results.length
      }

      if (this.state.showWorkPreferences) {
        console.log('testing 2')
        for (let i = 1; i <= loopLength; i++) {
          console.log('count work preference resullts', i)

          if (questions[i - 1] && results[i - 1]) {
            rows.push(
              <div key={i.toString() + "customAssessment"}>
                <div className="row-5 horizontal-padding-9">
                    <label className="profile-descriptor">{questions[i - 1].name}</label>
                    <p className="row-10">{results[i - 1].replace("[", "").replace("]", "").replace(/"/g,"")}</p>
                </div>
              </div>
            )
          }
        }
      }
    } else if (source === 'thirdPartyAssessments') {
      if (this.state.showThirdPartyAssessments && this.state.selectedApplication && this.state.selectedApplication.thirdPartyAssessmentResponses && this.state.selectedApplication.thirdPartyAssessmentResponses.length > 0) {
        for (let i = 1; i <= this.state.selectedApplication.thirdPartyAssessmentResponses.length; i++) {
          // console.log('count custom assessment resullts', i, this.state.selectedApplication.newCustomAssessmentResults[i - 1])
          if (this.state.selectedApplication.thirdPartyAssessmentResponses[i - 1]) {
            rows.push(
              <div key={i.toString() + "thirdPartyAssessmentResponses"}>
                <div className="row-5 horizontal-padding-9">
                    <label className="profile-descriptor">{this.state.selectedApplication.thirdPartyAssessmentResponses[i - 1].question}</label>
                    <p className="row-10">{this.state.selectedApplication.thirdPartyAssessmentResponses[i - 1].answer}</p>
                </div>
              </div>
            )
          }
        }
      }
    } else if (source === 'dealBreakers') {
      if (this.state.showDealBreakers && this.state.selectedApplication && this.state.selectedApplication.dealBreakerResponses && this.state.selectedApplication.dealBreakerResponses.length > 0) {
        for (let i = 1; i <= this.state.selectedApplication.dealBreakerResponses.length; i++) {
          // console.log('count custom assessment resullts', i, this.state.selectedApplication.newCustomAssessmentResults[i - 1])
          if (this.state.selectedApplication.dealBreakerResponses[i - 1]) {
            rows.push(
              <div key={i.toString() + "dealBreakerResponses"}>
                <div className="row-5 horizontal-padding-9">
                    <label className="profile-descriptor">{this.state.selectedApplication.dealBreakerResponses[i - 1].question}</label>
                    <p className="row-10">{this.state.selectedApplication.dealBreakerResponses[i - 1].answer}</p>
                </div>
              </div>
            )
          }
        }
      }
    } else if (source === 'diversity') {


      if (this.state.selectedApplication.race) {
        rows.push(
          <div key={source}>
            <div className="row-5 horizontal-padding-9">
                <label className="profile-descriptor">Race</label>
                <p className="row-10">{this.state.selectedApplication.race}</p>
            </div>
          </div>
        )
      }
    }

    // if (this.state.customAssessment) {
    //   let questions = this.state.customAssessment.questions
    //   let results = this.state.selectedApplication.customAssessmentResults
    //   if (source === 'ca') {
    //     //initiating values
    //   } else if (source === 'wp') {
    //     questions = this.state.wpQuestions
    //     results = this.state.selectedApplication.workPreferenceResults
    //   }
    //
    //   let loopLength = 0
    //   if (questions <= results) {
    //     loopLength = questions.length
    //   } else {
    //     loopLength = results.length
    //   }
    //
    //   if (source === 'ca' && this.state.showCustomAssessment) {
    //     console.log('testing 1')
    //     for (let i = 1; i <= loopLength; i++) {
    //       console.log('count custom assessment resullts', i)
    //
    //       rows.push(
    //         <div key={i.toString() + "customAssessment"}>
    //           <div className="row-5 horizontal-padding-9">
    //               <label className="profile-descriptor">{questions[i - 1].name}</label>
    //               <p className="profile-label">{results[i - 1]}</p>
    //           </div>
    //         </div>
    //       )
    //     }
    //   } else if (source === 'wp' && this.state.showWorkPreferences) {
    //     console.log('testing 2')
    //     for (let i = 1; i <= loopLength; i++) {
    //       console.log('count work preference resullts', i)
    //
    //       rows.push(
    //         <div key={i.toString() + "customAssessment"}>
    //           <div className="row-5 horizontal-padding-9">
    //               <label className="profile-descriptor">{questions[i - 1].name}</label>
    //               <p className="profile-label">{results[i - 1]}</p>
    //           </div>
    //         </div>
    //       )
    //     }
    //   } else {
    //     console.log('there was an error ', source, this.state.showCustomAssessment, this.state.showWorkPreferences)
    //   }
    // }

    return rows
  }

  toggleView(source) {
    console.log('toggleView called', source)

    if (source === 'ca') {
      if (this.state.showCustomAssessment) {
        this.setState({ showCustomAssessment: false, caRotation: 0 })
      } else {
        this.setState({ showCustomAssessment: true, caRotation: 90 })
      }
    } else if (source === 'wp') {
      if (this.state.showWorkPreferences) {
        this.setState({ showWorkPreferences: false, wpRotation: 0 })
      } else {
        this.setState({ showWorkPreferences: true, wpRotation: 90 })
      }
    } else if (source === 'thirdPartyAssessments') {
      if (this.state.showThirdPartyAssessments) {
        this.setState({ showThirdPartyAssessments: false, wpRotation: 0 })
      } else {
        this.setState({ showThirdPartyAssessments: true, wpRotation: 90 })
      }
    } else if (source === 'dealBreakers') {
      if (this.state.showDealBreakers) {
        this.setState({ showDealBreakers: false, wpRotation: 0 })
      } else {
        this.setState({ showDealBreakers: true, wpRotation: 90 })
      }
    } else if (source === 'diversity') {
      if (this.state.showWorkPreferences) {
        this.setState({ showDiversityInfo: false, wpRotation: 0 })
      } else {
        this.setState({ showDiversityInfo: true, wpRotation: 90 })
      }
    }
  }

  removeTag(type, index) {
    console.log('removeTag called', type, index)

    if (type === 'scorer') {
      let scorers = this.state.scorers
      scorers.splice(index, 1)
      this.setState({ scorers })
    } else {
      let assignedStaff = {}
      this.setState({ assignedStaff })
    }
  }

  addItem(type) {
    console.log('addItem called', type)

    this.setState({ errorMessage: null })

    if (type === 'scorer') {
      if (!this.state.scorerEmail) {
        this.setState({ errorMessage: 'Please add a valid email'})
      } else if (!this.state.scorerEmail.includes('@')) {
        this.setState({ errorMessage: 'Please add a valid email'})
      } else {
        let scorers = this.state.scorers
        scorers.push({
          email: this.state.scorerEmail, firstName: this.state.scorerFirstName, lastName: this.state.scorerLastName,
          jobTitle: this.state.scorerJobTitle, employerName: this.state.scorerEmployerName
        })
        this.setState({ scorers })
      }

    } else if (type === 'staff') {
      if (this.state.staffMember) {
        let assignedStaff = this.state.staffMember
        let staffMember = {}

        this.setState({ assignedStaff, staffMember })

      } else {
        // please add a staff member
        const errorMessage = 'please select a staff member'
        console.log(errorMessage)
        this.setState({ errorMessage })
      }
    }
  }

  assign(type) {
    console.log('assign called', type)

    this.setState({ errorMessage: null })

    if (type === 'scorer') {
      // configure scorer
      const scorers = this.state.scorers
      const appIds = [this.state.selectedApplication._id]

      // save assignments
      Axios.post('/api/applications/assign-people', { //sessions: sessions
        type, scorers, appIds })
      .then((response) => {

        if (response.data.success) {
          //save values
          console.log('Application saves worked', response.data);
          this.setState({ successMessage: 'Application saved successfully!' })

        } else {
          console.error('there was an error saving the application');
          this.setState({ errorMessage: response.data.message })
        }
      }).catch((error) => {
          console.log('Application save did not work', error);
          this.setState({ errorMessage: error })
      });

    } else if (type === 'staff'){
      // configure staff

      const assignedStaff = this.state.assignedStaff
      const appIds = [this.state.selectedApplication._id]

      // save assignments
      Axios.post('/api/applications/assign-people', { //sessions: sessions
        type, assignedStaff, appIds })
      .then((response) => {

        if (response.data.success) {
          //save values
          console.log('Application saves worked', response.data);
          this.setState({ successMessage: 'Application saved successfully!' })

        } else {
          console.error('there was an error saving the application');
          this.setState({ errorMessage: response.data.message })
        }
      }).catch((error) => {
          console.log('Application save did not work', error);
          this.setState({ errorMessage: error })
      });
    }
  }

  configureValuesText(type,values) {
    console.log('configureValuesText called')


    let valuesText = ''

    if (type === 'gravitateValues') {
      valuesText = "I tend to gravitate toward people that are "
    } else {
      valuesText = "I tend to gravitate toward employers that offer "
    }

    for (let i = 1; i <= values.length; i++) {
      if (values.lenth !== i) {
        valuesText = valuesText + ', and ' + values[i - 1]
      } else {
        valuesText = valuesText + ', ' + values[i - 1]
      }
    }

    return valuesText
  }

  renderEditView(fromModal) {
    console.log('renderEditView called', fromModal)

    let rowClass = "row-20 horizontal-padding"
    if (fromModal) {
      rowClass = "row-20"
    }

    return (
      <div key="renderEditView">
        {(window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) && (
          <div>
            {(this.state.selectedApplication.employerRanking || this.state.selectedApplication.employerFeedback || this.state.selectedApplication.liked || this.state.selectedApplication.disliked) && (
              <div className={rowClass}>
                <div className="standard-border padding-30">
                  <p className="heading-text-3">Employer Feedback</p>
                  <div className="spacer" />
                  {(this.state.selectedApplication.employerRanking) && (
                    <p className="row-5">Ranking: <label className="cta-color">{this.state.selectedApplication.employerRanking}</label></p>
                  )}

                  {(this.state.selectedApplication.liked) && (
                    <p className="cta-color row-5 description-text-2">Employer liked this candidate</p>
                  )}
                  {(this.state.selectedApplication.disliked) && (
                    <p className="error-color row-5 description-text-2">Employer disliked this candidate</p>
                  )}

                  <p className="description-text-2 row-5">{this.state.selectedApplication.employerFeedback}</p>
                </div>
              </div>
            )}

            {(window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) && (
              <div className={rowClass}>
                <div className="row-10">
                  <p className="heading-text-3">Assignments</p>
                </div>

                <div className="row-10">
                  <div className="container-left">
                    <div>
                      <div className="float-left">
                        <p>Scorers</p>
                      </div>
                      <div className="float-left left-padding">
                        <div className="mini-spacer" /><div className="mini-spacer" />
                        <button type="button" className="background-button" onClick={() => this.setState({ modalIsOpen: true, showAssignScorers: true, showAssignStaff: false, showEditView: false })}>
                          <img src={addCircleOutlineIcon} alt="Compass add circle outline icon" className="image-auto-22" />
                        </button>
                      </div>
                      <div className="clear" />
                    </div>

                    <div className="spacer" />

                    {(this.state.scorers && this.state.scorers.length > 0) ? (
                      <div>
                        {this.state.scorers.map((value, optionIndex) =>
                          <div key={optionIndex} className="float-left row-3">
                            <button className="background-button" onClick={() => this.setState({ modalIsOpen: true, showAssignScorers: true, showAssignStaff: false, showEditView: false })}>
                              <div className="float-left right-padding-5">
                                <div className="half-spacer" />
                                <div className="tag-container-inactive">
                                  {(value.firstName) ? (
                                    <p className="description-text-2">{value.email} - {value.firstName} {value.lastName}</p>
                                  ) : (
                                    <p className="description-text-2">{value.email}</p>
                                  )}
                                </div>
                                <div className="half-spacer" />
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        <p className="description-text-2 description-text-color">Assign external professional(s) to score this application</p>
                      </div>
                    )}

                    <div className="clear" />
                  </div>
                  <div className="container-left">
                    <div>
                      <div className="float-left">
                        <p>Staff</p>
                      </div>
                      <div className="float-left left-padding">
                        <div className="mini-spacer" /><div className="mini-spacer" />
                        <button type="button" className="background-button" onClick={() => this.setState({ modalIsOpen: true, showAssignScorers: false, showAssignStaff: true })}>
                          <img src={addCircleOutlineIcon} alt="Compass add circle outline icon" className="image-auto-22" />
                        </button>
                      </div>
                      <div className="clear" />
                    </div>

                    <div className="spacer" />

                    {(this.state.assignedStaff && this.state.assignedStaff.length > 0) ? (
                      <div>
                        {(this.state.assignedStaff && this.state.assignedStaff.firstName) && (
                          <div className="row-3">
                            <button className="background-button" onClick={() => this.setState({ modalIsOpen: true, showAssignScorers: false, showAssignStaff: true })}>
                              <div className="float-left right-padding-5">
                                <div className="half-spacer" />
                                <div className="tag-container-inactive">
                                  <p className="description-text-2">{this.state.assignedStaff.firstName} {this.state.assignedStaff.lastName}</p>
                                </div>
                                <div className="half-spacer" />
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        <p className="description-text-2 description-text-color">Assign this application to internal staff evaluation</p>
                      </div>
                    )}

                  </div>
                  <div className="clear" />
                </div>
              </div>
            )}

            {(this.state.selectedApplication.scores && this.state.selectedApplication.scores.length > 0) && (
              <div className="{rowClass}">
                <div className="row-10">
                  <p className="heading-text-3">Scores</p>
                </div>

                <div className="row-10">
                  {this.state.selectedApplication.scores.map((value, optionIndex) =>
                    <div key={optionIndex} className="full-width row-5">
                      <div className="standard-border padding-20">

                        <div className="row-10">
                          <p className="heading-text-3">#{optionIndex + 1}) {value.scorer.firstName} {value.scorer.lastName}</p>
                          {(value.scorer.jobTitle && value.scorer.employerName) && (
                            <div>
                              <p className="description-text-2">{value.scorer.jobTitle} @ {value.scorer.employerName}</p>
                            </div>
                          )}
                        </div>

                        {(value.overallScore && value.overallScore !== '') && (
                          <div className="row-10">
                            <p className="heading-text-1 cta-color">{value.overallScore}</p>
                            <p className="heading-text-4 cta-color">Overall Score</p>
                          </div>
                        )}

                        {(value.suppScores && value.suppScores.length > 0) && (
                          <div>
                            {value.suppScores.map((value2, optionIndex2) =>
                              <div key={optionIndex2} className="container-left row-3">
                                <div className="float-left right-padding-5">

                                  <p className="heading-text-1 cta-color">{value2.score}</p>
                                  <p className="heading-text-4 cta-color">{value2.category}</p>

                                  <div className="row-3">
                                    <p className="description-text-2"><label className="half-bold-text">Instrux:</label> {value2.instructions}</p>
                                  </div>

                                  {(value2.questions && value2.questions.length > 0) && (
                                    <div>
                                      {value2.questions.map((value3, optionIndex3) =>
                                        <div key={optionIndex3} className="float-left row-3">
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  <div className="clear" />

                                  {(value2.rubric && value2.rubric.length > 0) && (
                                    <div>
                                      <div className="row-5">
                                        <p className="description-text-2 half-bold-text">Rubric:</p>
                                      </div>

                                      {value2.rubric.map((value3, optionIndex3) =>
                                        <div key={optionIndex3} className="row-3">
                                          <p className="description-text-2">{value3.score}</p>
                                          <p className="description-text-5">{value3.description}</p>
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  <div className="clear" />

                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="clear" />

                        {(value.feedback && value.feedback !== '') && (
                          <div className="row-10">
                            <p><label className="description-text-2 half-bold-text">Feedback for the Applicant:</label> {value.feedback}</p>
                          </div>
                        )}

                        {(value.notes && value.notes !== '') && (
                          <div className="row-10">
                            <p><label className="description-text-2 half-bold-text">Notes for Staff ({this.state.orgName}):</label> {value.notes}</p>
                          </div>
                        )}

                      </div>
                    </div>
                  )}

                  <div className="clear" />
                </div>
              </div>
            )}

          </div>
        )}

        {(window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) ? (
          <div>
            {(this.state.selectedJob.postType === "Track" || this.state.selectedJob.subPostType === 'Track') ? (
              <div>
                <div className="padding-20">
                  <div className="horizontal-padding-5">
                    <label className="profile-label">Track Approvals</label>
                    <p className="profile-descriptor">Approve this candidate to apply for jobs with each track</p>
                  </div>
                  {this.renderApprovals()}
                </div>
                <div className="clear"/>
                <div className="spacer"/><div className="spacer"/><div className="half-spacer"/>
                <hr className={(fromModal) ? "" : "horizontal-margin-40"} />
                <div className="spacer"/>

                <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
                    <div className="row-10">
                      <label className="heading-text-5">Interview Scores</label>
                    </div>

                    <div className="spacer" /><div className="spacer" />
                    {this.renderInterviews()}
                    {/*
                    <select name="interviewScore" value={this.state.interviewScore} onChange={this.formChangeHandler} className="dropdown">
                      {this.state.scoreOptions.map(value =>
                        <option key={value.key} value={value}>{value}</option>
                      )}
                    </select>*/}
                </div>
                <div className="clear"/>

                <div className="spacer"/>
                <hr className="horizontal-margin-40" />
                <div className="spacer"/>
              </div>
            ) : (
              <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
                  <div className="half-spacer" />
                  <div className="row-10">
                    <label className="heading-text-5">Interview Scores</label>
                  </div>
                  <div className="spacer" />
                  <div className="relative-column-60">
                    <p className="profile-descriptor">Interviewer Name</p>
                    <input type="text" className="text-field" placeholder="Add the name..." name="interview|name|0" value={this.state.interview.interviewerName} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="relative-column-20">
                    <p className="profile-descriptor">Interview Date</p>
                    <input type="date" className="date-field white-background" placeholder="Add a date..." name="interview|date|0" value={this.state.interview.date} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="relative-column-20">
                    <p className="profile-descriptor">Interview Score</p>
                    <select name="interview|score|0" value={this.state.interview.score} onChange={this.formChangeHandler} className="dropdown">
                      {this.state.scoreOptions.map(value =>
                        <option key={value.key} value={value}>{value}</option>
                      )}
                    </select>
                  </div>
                  <div className="clear"/>

                  {(this.state.selectedJob.placementPartners && this.state.selectedJob.placementPartners.includes(this.state.org)) ? (
                    <div>
                    </div>
                  ) : (
                    <div>
                      <div className="row-10 float-right">
                        <Link className="secret-link" to={this.state.pathPrefix + '/postings/' + this.state.selectedApplication._id + '/applications/' + this.state.selectedApplication._id + '/interview'} state={{ selectedApplication: this.state.selectedApplication, interview: this.state.interview, selectedJob: this.state.selectedJob }}>
                          <div className="float-right horizontal-padding-7">
                            <div className="half-spacer" /><div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" />
                            <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className="image-auto-12"/>
                          </div>
                          <div className="float-right horizontal-padding-7">
                            <label className="description-text-2 description-text-color half-bold-text">Edit Details</label>
                            <div className="half-spacer" />
                          </div>
                        </Link>
                      </div>
                      <div className="clear"/>
                    </div>
                  )}

                  {/*
                  <select name="interviewScore" value={this.state.interviewScore} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.scoreOptions.map(value =>
                      <option key={value.key} value={value}>{value}</option>
                    )}
                  </select>*/}
              </div>
            )}

            {(this.state.customAssessment && !fromModal) && (
              <div>
                <div className="row-10 horizontal-padding">
                  <label className="heading-text-5">Custom Assessment Results (Application Form)</label>
                </div>
                <div className="float-left row-10 horizontal-padding">
                  <a className="background-button" onClick={() => this.toggleView('ca')}>
                    <div className="float-left row-5 horizontal-padding-7">
                      <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className={(this.state.caRotation === 90) ? "image-auto-16 rotate-90" : "image-auto-16"} />
                    </div>
                    <div className="float-left right-padding">
                      <label>{this.state.customAssessment.questions.length} Answers</label>
                    </div>
                  </a>
                </div>
                <div className="clear" />
                {this.renderQandA('ca')}
                <div className="spacer" />
              </div>
            )}

            <div className="spacer"/>
            <hr className="horizontal-margin-40" />
            <div className="spacer"/>

            {(this.state.workPreferenceResults && !fromModal) && (
              <div>
                <div className="row-10 horizontal-padding">
                  <label className="heading-text-5">Work Preference Results</label>
                </div>
                <div className="float-left row-10 horizontal-padding">
                  <a className="background-button" onClick={() => this.toggleView('wp')}>
                    <div className="float-left row-5 horizontal-padding-7">
                      <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className={(this.state.showWorkPreferences) ? "image-auto-16 rotate-90" : "image-auto-16"}/>
                    </div>
                    <div className="float-left right-padding">
                      <label>{(this.state.workPreferenceResults) ? this.state.workPreferenceResults.length : "0"} Answers</label>
                    </div>
                  </a>
                </div>
                <div className="clear" />
                {this.renderQandA('wp')}

                <div className="spacer"/>
                <hr className="horizontal-margin-40" />
                <div className="spacer"/>

              </div>
            )}

            {(this.state.selectedApplication.thirdPartyAssessmentResponses && this.state.selectedApplication.thirdPartyAssessmentResponses.length > 0 && !fromModal) && (
              <div>
                <div className="row-10 horizontal-padding">
                  <label className="heading-text-5">Third Party Assessment Responses</label>
                </div>
                <div className="float-left row-10 horizontal-padding">
                  <a className="background-button" onClick={() => this.toggleView('thirdPartyAssessments')}>
                    <div className="float-left row-5 horizontal-padding-7">
                      <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className={(this.state.showThirdPartyAssessments) ? "image-auto-16 rotate-90" : "image-auto-16"}/>
                    </div>
                    <div className="float-left right-padding">
                      <label>{this.state.selectedApplication.thirdPartyAssessmentResponses.length} Answers</label>
                    </div>
                  </a>
                </div>
                <div className="clear" />
                {this.renderQandA('thirdPartyAssessments')}

                <div className="spacer"/>
                <hr className="horizontal-margin-40" />
                <div className="spacer"/>

              </div>
            )}

            {(this.state.selectedApplication.dealBreakerResponses && this.state.selectedApplication.dealBreakerResponses.length > 0 && !fromModal) && (
              <div>
                <div className="row-10 horizontal-padding">
                  <label className="heading-text-5">Screening Question Responses</label>
                </div>
                <div className="float-left row-10 horizontal-padding">
                  <a className="background-button" onClick={() => this.toggleView('dealBreakers')}>
                    <div className="float-left row-5 horizontal-padding-7">
                      <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className={(this.state.showDealBreakers) ? "image-auto-16 rotate-90" : "image-auto-16"}/>
                    </div>
                    <div className="float-left right-padding">
                      <label>{this.state.selectedApplication.dealBreakerResponses.length} Answers</label>
                    </div>
                  </a>
                </div>
                <div className="clear" />
                {this.renderQandA('dealBreakers')}

                <div className="spacer"/>
                <hr className="horizontal-margin-40" />
                <div className="spacer"/>

              </div>
            )}

            {(this.state.selectedApplication.diversityInfo && !fromModal) && (
              <div>
                <div className="row-10 horizontal-padding">
                  <label className="profile-label">Diversity / Adversity Info</label>
                </div>
                <div className="float-left row-10 horizontal-padding">
                  <a className="background-button" onClick={() => this.toggleView('diversity')}>
                    <div className="float-left row-5 horizontal-padding-7">
                      <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className={(this.state.showDiversityInfo) ? "image-auto-16 rotate-90" : "image-auto-16"}/>
                    </div>
                    <div className="float-left right-padding">
                      <label>{this.state.selectedApplication.diversityInfo.length} Answers</label>
                    </div>
                  </a>
                </div>
                <div className="clear" />
                {this.renderQandA('diversity')}

                <div className="spacer"/>
                <hr className="horizontal-margin-30" />
                <div className="spacer"/>

              </div>
            )}

            {(this.state.org === 'bixel' || this.state.org === 'unite-la') && (
              <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
                <div className="float-left right-padding-30">
                  <label className="profile-label">Is Subsidy Eligible?</label>
                  <Switch
                    onChange={(change) => this.setState({ isSubsidyEligible: change, applicationFormHasChanged: true })}
                    checked={this.state.isSubsidyEligible}
                    id="normal-switch"
                  />
                </div>
                <div className="float-left">
                  <div className="float-left">
                    <label className="profile-label">Is WorkForce Ready?</label>
                    <Switch
                      onChange={(change) => this.setState({ isWorkforceReady: change, applicationFormHasChanged: true })}
                      checked={this.state.isWorkforceReady}
                      id="normal-switch"
                    />
                  </div>
                </div>
                <div className="clear" />
              </div>
            )}

            {(this.state.selectedJob.placementPartners && this.state.selectedJob.placementPartners.includes(this.state.org)) ? (
              <div>
              </div>
            ) : (
              <div>
                <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
                    <label className="heading-text-5">Stage</label>
                    <div className="spacer" />
                    <select name="stage" value={this.state.stage} onChange={this.formChangeHandler} className="dropdown">
                      {this.state.stageOptions.map(value =>
                        <option key={value} value={value}>{value}</option>
                      )}
                    </select>
                </div>
              </div>
            )}

            <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
              <div className="row-10">
                <label className="heading-text-5">Internal Notes</label>
              </div>

              <textarea type="text" className="notes" placeholder="Write some private notes for internal use..." name="notes" value={this.state.notes} onChange={(this.formChangeHandler)}></textarea>
              <div className="top-margin-5 bottom-margin">
                <p className="profile-descriptor">Note: these notes are for internal purposes.</p>
              </div>
            </div>

            <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>

              <div className="row-10">
                <label className="heading-text-5">Overall Feedback for Candidate</label>
              </div>
              <textarea type="text" className="notes" placeholder="Share some detailed feedback with the candidate..." name="feedback" value={this.state.feedback} onChange={(this.formChangeHandler)}></textarea>
              <div className="top-margin-5 bottom-margin">
                <p className="profile-descriptor">Note: this feedback is automatically emailed to the candidate.</p>
              </div>
            </div>

            <div className="row-20">
              <button className="btn btn-primary" onClick={() => this.saveApplication()}>Save Changes</button>
            </div>

            { (this.state.checklistErrorMessage!== '') && <p className="error-message">{this.state.checklistErrorMessage}</p> }
            { (this.state.serverPostSuccess) ? (
              <div className="left-margin-30 row-20">
                <p className="success-message">{this.state.serverSuccessMessage}</p>
              </div>
            ) : (
              <div className="left-margin-30 row-10">
                <p className="error-message">{this.state.serverErrorMessage}</p>
              </div>
            )}
          </div>
        ) : (
          <div>
            {(window.location.pathname.includes('/career-seekers/')) ? (
              <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
                <div className={(fromModal) ? "top-padding-30 bottom-padding" : "top-padding-30 bottom-padding horizontal-padding"}>
                  <label className="heading-text-5">Career Track Comparison</label>
                  <div className="spacer" />
                </div>
                {this.renderApprovals()}
                <div className="clear" />
              </div>
            ) : (
              <div>
                {(!this.state.onlyFeedback) && (
                  <div className={(fromModal) ? "row-10" : "row-10 horizontal-padding"}>
                    <DecideOnCandidate
                      selectedApplication={this.state.selectedApplication} selectedIndex={this.state.selectedIndex} selectedJob={this.state.selectedJob}
                      applications={this.state.applications} selectedBenchmark={this.state.benchmark} accountCode={this.state.accountCode}
                      orgCode={this.state.org} id={this.state.id}
                    />
                  </div>
                )}

              </div>
            )}

          </div>
        )}
      </div>
    )
  }

  actionClicked(type) {
    console.log('actionClicked called', type)

    if (type === 'refer') {

      let selectedApplication = this.state.selectedApplication

      let rankCount = 0

      if (this.state.selectedJob.placementPartners && this.state.selectedJob.placementPartners.includes(this.state.org)) {
        if (selectedApplication.partnerEvaluations && selectedApplication.partnerEvaluations.some(pe => pe.orgCode === this.state.org)) {
          const evalIndex = selectedApplication.partnerEvaluations.findIndex(pe => pe.orgCode === this.state.org);
          if (selectedApplication.partnerEvaluations[evalIndex].rank) {
            rankCount = rankCount + 1
          }
        }
      } else if (selectedApplication.rank) {
        rankCount = rankCount + 1
      }

      if (!selectedApplication.rank) {
        if (this.state.selectedJob.placementPartners && this.state.selectedJob.placementPartners.includes(this.state.org)) {
          if (selectedApplication.partnerEvaluations && selectedApplication.partnerEvaluations.some(pe => pe.orgCode === this.state.org)) {
            const evalIndex = selectedApplication.partnerEvaluations.findIndex(pe => pe.orgCode === this.state.org);
            if (selectedApplication.partnerEvaluations[evalIndex].rank) {
              selectedApplication.partnerEvaluations[evalIndex]['rank'] = null
            } else {
              selectedApplication.partnerEvaluations[evalIndex].rank = rankCount + 1
            }
          } else {

            if (selectedApplication.partnerEvaluations && selectedApplication.partnerEvaluations.length > 0) {
              selectedApplication.partnerEvaluations[0].rank = rankCount + 1
            } else {
              let partnerEvaluations = [{ orgCode: this.state.org, rank: rankCount + 1 }]
              selectedApplication['partnerEvaluations'] = partnerEvaluations
            }
          }

        } else {

          if (selectedApplication.rank) {
            selectedApplication['rank'] = null
          } else {
            selectedApplication['rank'] = rankCount + 1
          }
        }
      }

      // save

      const segueLink = this.state.pathPrefix + '/postings/' + this.state.selectedJob._id + '/top-candidates'
      // const passedState = { selectedJob: this.state.selectedJob, applications: this.props.applications, selectedBenchmark: this.props.benchmark }
      // console.log('--- passedState: ', passedState)
      // this.props.navigate(url, { state: passedState })
      this.updateRank(selectedApplication, segueLink)
    } else if (type === 'message') {

      const url = this.state.pathPrefix + '/postings/' + this.state.selectedApplication.postingId + '/messages/' + this.state.selectedApplication.firstName + this.state.selectedApplication.lastName
      const passedState = { selectedApplication: this.state.selectedApplication }
      this.props.navigate(url, { state: passedState })
    }
  }

  updateRank(application, segueLink) {
    console.log('updateRank called', application, segueLink)

    const _id = application._id
    const updateRank = true
    const rank = application.rank
    let partnerEvaluations = null
    if (this.state.selectedJob.placementPartners && this.state.selectedJob.placementPartners.includes(this.state.org)) {
      partnerEvaluations = application.partnerEvaluations
    }

    const updatedAt = new Date()

    Axios.post('/api/applications/update-by-id', { //sessions: sessions
      _id, updateRank, rank, partnerEvaluations, updatedAt })
    .then((response) => {
      if (response.data.success) {
        //save values
        console.log('Application save worked', response.data);
        this.setState({
          serverPostSuccess: true,
          serverSuccessMessage: 'Application saved successfully!'
        })

        if (segueLink) {

          let applications = this.props.applications
          if (applications) {
            for (let i = 1; i <= applications.length; i++) {
              if (applications[i - 1]._id === _id) {
                applications[i - 1]['rank'] = rank
              }
            }
          }
          const passedState = { selectedJob: this.state.selectedJob, applications, selectedBenchmark: this.props.benchmark }
          // console.log('--- passedState: ', passedState)
          this.props.navigate(segueLink, { state: passedState })
          // this.props.navigate(segueLink, { selectedJob: this.state.selectedJob, applications: this.state.applications, selectedBenchmark: this.state.benchmark })
        }

      } else {
        console.error('there was an error saving the application');
        this.setState({
          serverPostSuccess: false,
          serverErrorMessage: response.data.message,
        })
      }
    }).catch((error) => {
        console.log('Application save did not work', error);
    });
  }

  exportInfo() {
    console.log('exportInfo called')

    // const reportType = 'applications'
    // const orgCode = org
    // const placementPartners = this.state.placementPartners
    // const selectedWork = this.state.selectedJob
    //
    // // Axios.put('/api/reporting/general', { reportType, orgCode, placementPartners, selectedWork, department, pathway, accountCode, afterDate, beforeDate, resLimit })
    // Axios.put('/api/reporting/general', { reportType, orgCode, placementPartners, selectedWork })
    // .then((response) => {
    //     console.log('about to query reports')
    //     if (response.data.success) {
    //       console.log('Reporting query worked', response.data);
    //
    //       csvData.push(
    //         [ "Email","First Name","Last Name","Posting ID","Posting Title","Posting Employer","Posting Location","Picture URL","Cell Number","Alternative Email","Alternative Phone Number","Education Status", "School Name","School Degree","School Major","School Grad Year","School End Date","Zip Code","Previously Interned","Stage","Resume URL","Cover Letter URL","Linked In URL","Portfolio URL","Identification URL","Letter of Recommendation URL","Transcript URL","Date of Birth","Pathway","Address","City","State","Country","Language","Race","Races","Self Described Race","Gender","Preferred Pronoun","Veteran","Work Authorization","Number of Members in Household","Household Income","Foster Youth","Homeless","Incarcerated","Adversity List","Completed Training","Interviewed","Referred","Referral Code","Interest Scores","Trait Scores","Endorsement Count","Experience Hours","Project Hours","Volunteer Hours","Notes","Match Score","Referral Rank","Org Feedback","Is Subsidy Eligible","Referral Message to Employer","Employer Ranking","Employer Feedback","Liked by Employer","Disliked by Employer","Offer Decision by Candidate", "Departments","Pathways","Is Vaccinated","Created At", "Updated At" ]
    //       )
    //
    //       if (this.state.org === 'c2c') {
    //         let tempData = csvData[0]
    //         tempData = tempData.concat(["Political Alignment","State Registration","Current Congressional District","Hometown","Home Congressional District"])
    //         csvData[0] = tempData
    //       }
    //
    //       const applications = response.data.applications
    //       if (applications && applications.length > 0) {
    //
    //         let commaStartingValue = /,/g
    //         let commaReplacementValue = ";"
    //
    //         for (let i = 1; i <= applications.length; i++) {
    //
    //           const email = applications[i - 1].email
    //           const firstName = applications[i - 1].firstName
    //           const lastName = applications[i - 1].lastName
    //           const postingId = applications[i - 1].postingId
    //
    //           let postingTitle = ''
    //           if (applications[i - 1].postingTitle) {
    //             postingTitle = applications[i - 1].postingTitle.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let postingEmployerName = ''
    //           if (applications[i - 1].postingEmployerName) {
    //             postingEmployerName = applications[i - 1].postingEmployerName.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let postingLocation = ''
    //           if (applications[i - 1].postingLocation) {
    //             postingLocation = applications[i - 1].postingLocation.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let pictureURL = ''
    //           if (applications[i - 1].pictureURL) {
    //             pictureURL = applications[i - 1].pictureURL
    //           }
    //
    //           let phoneNumber = ''
    //           if (applications[i - 1].phoneNumber) {
    //             phoneNumber = applications[i - 1].phoneNumber
    //           }
    //
    //           let alternativeEmail = ''
    //           if (applications[i - 1].alternativeEmail) {
    //             alternativeEmail = applications[i - 1].alternativeEmail
    //           }
    //
    //           let alternativePhoneNumber = ''
    //           if (applications[i - 1].alternativePhoneNumber) {
    //             alternativePhoneNumber = applications[i - 1].alternativePhoneNumber
    //           }
    //
    //           let educationStatus = ''
    //           if (applications[i - 1].educationStatus) {
    //             educationStatus = applications[i - 1].educationStatus
    //           }
    //
    //           let schoolName = applications[i - 1].schoolName
    //           if (applications[i - 1].schoolName) {
    //             schoolName = applications[i - 1].schoolName.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let degree = applications[i - 1].degree
    //           if (applications[i - 1].degree) {
    //             degree = applications[i - 1].degree.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let major = ''
    //           if (applications[i - 1].major) {
    //             // console.log('mic check 2: ', applications[i - 1].email)
    //             major = applications[i - 1].major.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //
    //           let gradYear = ''
    //           if (applications[i - 1].gradYear) {
    //             gradYear = applications[i - 1].gradYear.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let endDate = ''
    //           if (applications[i - 1].endDate) {
    //             endDate = applications[i - 1].endDate.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let zipcode = ''
    //           if (applications[i - 1].zipcode) {
    //             zipcode = applications[i - 1].zipcode.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let previouslyInterned = ''
    //           if (applications[i - 1].previouslyInterned) {
    //             previouslyInterned = applications[i - 1].previouslyInterned.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let stage = ''
    //           if (applications[i - 1].stage) {
    //             stage = applications[i - 1].stage.replace(commaStartingValue,commaReplacementValue).replace(/#/g,"")
    //           }
    //
    //           let resumeURL = ''
    //           if (applications[i - 1].resumeURL) {
    //             resumeURL = applications[i - 1].resumeURL.replace(/#/g,"")
    //           }
    //
    //           let coverLetterURL = ''
    //           if (applications[i - 1].coverLetterURL) {
    //             coverLetterURL = applications[i - 1].coverLetterURL.replace(/#/g,"")
    //           }
    //
    //           let linkedInURL = ''
    //           if (applications[i - 1].linkedInURL) {
    //             linkedInURL = applications[i - 1].linkedInURL.replace(/#/g,"")
    //           }
    //
    //           let customWebsiteURL = ''
    //           if (applications[i - 1].customWebsiteURL) {
    //             //this is not right
    //             customWebsiteURL = applications[i - 1].customWebsiteURL.replace(/#/g,"")
    //           }
    //
    //           let identificationURL = ''
    //           if (applications[i - 1].identificationURL) {
    //             identificationURL = applications[i - 1].identificationURL.replace(/#/g,"")
    //           }
    //
    //           let letterOfRecommendationURL = ''
    //           if (applications[i - 1].letterOfRecommendationURL) {
    //             letterOfRecommendationURL = applications[i - 1].letterOfRecommendationURL.replace(/#/g,"")
    //           }
    //
    //           let transcriptURL = ''
    //           if (applications[i - 1].transcriptURL) {
    //             transcriptURL = applications[i - 1].transcriptURL.replace(/#/g,"")
    //           }
    //
    //           let dateOfBirth = ''
    //           if (applications[i - 1].dateOfBirth) {
    //             dateOfBirth = applications[i - 1].dateOfBirth.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let pathway = ''
    //           if (applications[i - 1].pathway) {
    //             pathway = applications[i - 1].pathway.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let address = ''
    //           if (applications[i - 1].address) {
    //             address = applications[i - 1].address.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let city = ''
    //           if (applications[i - 1].city) {
    //             city = applications[i - 1].city.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let state = ''
    //           if (applications[i - 1].state) {
    //             state = applications[i - 1].state.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let country = ''
    //           if (applications[i - 1].country) {
    //             country = applications[i - 1].country.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let language = ''
    //           if (applications[i - 1].language) {
    //             language = applications[i - 1].language.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let race = ''
    //           if (applications[i - 1].race) {
    //             race = applications[i - 1].race.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let races = ''
    //           if (applications[i - 1].races && applications[i - 1].races.length > 0) {
    //             races = applications[i - 1].races.join(',').replace(/,/g,';')
    //           }
    //
    //           let selfDescribedRace = ''
    //           if (applications[i - 1].selfDescribedRace) {
    //             selfDescribedRace = applications[i - 1].selfDescribedRace.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let gender = ''
    //           if (applications[i - 1].gender) {
    //             gender = applications[i - 1].gender.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let preferredPronoun = ''
    //           if (applications[i - 1].preferredPronoun) {
    //             preferredPronoun = applications[i - 1].preferredPronoun.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let veteran = ''
    //           if (applications[i - 1].veteran) {
    //             veteran = applications[i - 1].veteran.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let workAuthorization = ''
    //           if (applications[i - 1].workAuthorization) {
    //             workAuthorization = applications[i - 1].workAuthorization.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let numberOfMembers = ''
    //           if (applications[i - 1].numberOfMembers) {
    //             numberOfMembers = applications[i - 1].numberOfMembers.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let householdIncome = ''
    //           if (applications[i - 1].householdIncome) {
    //             householdIncome = applications[i - 1].householdIncome.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let fosterYouth = ''
    //           if (applications[i - 1].fosterYouth) {
    //             fosterYouth = applications[i - 1].fosterYouth.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let homeless = ''
    //           if (applications[i - 1].homeless) {
    //             homeless = applications[i - 1].homeless.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let incarcerated = ''
    //           if (applications[i - 1].incarcerated) {
    //             incarcerated = applications[i - 1].incarcerated.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let adversityList = ''
    //           if (applications[i - 1].adversityList && applications[i - 1].adversityList.length > 0) {
    //             adversityList = applications[i - 1].adversityList.join(',').replace(/,/g,';')
    //           }
    //
    //           if (applications[i - 1].isWorkforceReady) {
    //             console.log('show workforce: ', applications[i - 1].isWorkforceReady)
    //           }
    //
    //           let completedWorkforceReady = 'NO'
    //           if (applications[i - 1].isWorkforceReady) {
    //             completedWorkforceReady = 'YES'
    //           }
    //
    //           let interviewed = 'NO'
    //           if (applications[i - 1].interviews.length && applications[i - 1].interviews.length > 0) {
    //             interviewed = 'YES'
    //           }
    //
    //           let referred = 'NO'
    //           if (applications[i - 1].rank) {
    //             referred = 'YES'
    //           }
    //
    //           let referralCode = ''
    //           if (applications[i - 1].referralCode) {
    //             referralCode = applications[i - 1].referralCode.replace(/,/g,";").replace(/#/g,"")
    //           }
    //
    //           let interestScoreArray = []
    //           let interestScores = ''
    //           if (applications[i - 1].interestResults) {
    //             if (applications[i - 1].interestResults.length !== 0) {
    //               for (let j = 1; j <= applications[i - 1].interestResults.length; j++) {
    //                 console.log(i)
    //
    //                 interestScoreArray.push(applications[i - 1].interestResults[j - 1].name + "-" + applications[i - 1].interestResults[j - 1].score)
    //               }
    //               interestScores = interestScoreArray.join(commaReplacementValue)
    //             }
    //           }
    //
    //           let traitScores = ''
    //           if (applications[i - 1].personalityResults) {
    //             let fiveFactors = applications[i - 1].personalityResults.fiveFactors
    //             traitScores = 'Openness-' + fiveFactors.opennessScore + '; Conscientiousness-' + fiveFactors.conscientiousnessScore + '; Extraversion-' + fiveFactors.extraversionScore + '; Agreeableness-' + fiveFactors.agreeablenessScore + '; Neuroticism' + fiveFactors.neuroticismScore
    //           }
    //
    //           let endorsementCount = 0
    //           if (applications[i - 1].endorsements) {
    //             endorsementCount = applications[i - 1].endorsements.length
    //           }
    //
    //           let experienceHours = ''
    //           if (applications[i - 1].experienceHours) {
    //             experienceHours = applications[i - 1].experienceHours
    //           }
    //
    //           let projectHours = ''
    //           if (applications[i - 1].projectHours) {
    //             projectHours = applications[i - 1].projectHours
    //           }
    //
    //           let volunteerHours = ''
    //           if (applications[i - 1].volunteerHours) {
    //             volunteerHours = applications[i - 1].volunteerHours
    //           }
    //
    //           let notes = ''
    //           if (applications[i - 1].notes) {
    //             notes = applications[i - 1].notes.replace(/,/g,';').replace(/#/g,';')
    //           }
    //
    //           let match = ''
    //           if (applications[i - 1].match) {
    //             match = applications[i - 1].match
    //           }
    //
    //           let rank = ''
    //           if (applications[i - 1].rank) {
    //             rank = applications[i - 1].rank
    //           }
    //
    //           let feedback = ''
    //           if (applications[i - 1].feedback) {
    //             feedback = applications[i - 1].feedback
    //           }
    //
    //           let isSubsidyEligible = ''
    //           if (applications[i - 1].isSubsidyEligible) {
    //             isSubsidyEligible = 'YES'
    //           }
    //
    //           let employerMessage = ''
    //           if (applications[i - 1].employerMessage) {
    //             employerMessage = applications[i - 1].employerMessage.replace(/,/g,';').replace(/#/g,';')
    //           }
    //
    //           let employerRanking = ''
    //           if (applications[i - 1].employerRanking) {
    //             employerRanking = applications[i - 1].employerRanking
    //           }
    //
    //           let employerFeedback = ''
    //           if (applications[i - 1].employerFeedback) {
    //             employerFeedback = applications[i - 1].employerFeedback.replace(/,/g,';').replace(/#/g,';')
    //           }
    //
    //           let liked = ''
    //           if (applications[i - 1].liked) {
    //             liked = 'YES'
    //           }
    //
    //           let disliked = ''
    //           if (applications[i - 1].disliked) {
    //             disliked = 'YES'
    //           }
    //
    //           let decision = ''
    //           if (applications[i - 1].decision) {
    //             decision = applications[i - 1].decision
    //           }
    //
    //           let departments = ''
    //           if (applications[i - 1].departments) {
    //             for (let j = 1; j <= applications[i - 1].departments.length; j++) {
    //               if (applications[i - 1].departments[j - 1] && applications[i - 1].departments[j - 1].name) {
    //                 if (departments === '') {
    //                   departments = applications[i - 1].departments[j - 1].name.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //                 } else {
    //                   departments = departments + '; ' + applications[i - 1].departments[j - 1].name.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //                 }
    //               }
    //             }
    //           }
    //
    //           let pathways = ''
    //           if (applications[i - 1].pathways) {
    //             for (let j = 1; j <= applications[i - 1].pathways.length; j++) {
    //               if (applications[i - 1].pathways[j - 1] && applications[i - 1].pathways[j - 1].title) {
    //                 if (pathways === '') {
    //                   pathways = applications[i - 1].pathways[j - 1].title.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //                 } else {
    //                   pathways = pathways + '; ' + applications[i - 1].pathways[j - 1].title.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //                 }
    //               }
    //             }
    //           }
    //
    //           let isVaccinated = ''
    //           if (applications[i - 1].isVaccinated) {
    //             isVaccinated = applications[i - 1].isVaccinated
    //           }
    //
    //           const createdAt = applications[i - 1].createdAt
    //           const updatedAt = applications[i - 1].updatedAt
    //
    //           csvData.push([
    //             email, firstName, lastName, postingId, postingTitle, postingEmployerName, postingLocation, pictureURL,
    //             phoneNumber, alternativeEmail, alternativePhoneNumber, educationStatus,
    //             schoolName, degree, major, gradYear, endDate,
    //             zipcode, previouslyInterned, stage, resumeURL, coverLetterURL, linkedInURL, customWebsiteURL,
    //             identificationURL, letterOfRecommendationURL, transcriptURL,
    //             dateOfBirth, pathway, address, city, state, country, language,
    //             race, races, selfDescribedRace, gender, preferredPronoun,
    //             veteran, workAuthorization, numberOfMembers, householdIncome,
    //             fosterYouth, homeless, incarcerated, adversityList,
    //             completedWorkforceReady,interviewed,referred, referralCode,
    //             interestScores, traitScores, endorsementCount,
    //             experienceHours, projectHours, volunteerHours, notes, match, rank,
    //             feedback,isSubsidyEligible, employerMessage, employerRanking, employerFeedback, liked, disliked, decision,
    //             departments, pathways, isVaccinated,
    //             createdAt, updatedAt
    //           ])
    //
    //           if (this.state.org === 'c2c') {
    //
    //             let politicalAlignment = ''
    //             if (applications[i - 1].politicalAlignment) {
    //               politicalAlignment = applications[i - 1].politicalAlignment.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //             }
    //
    //             let stateRegistration = ''
    //             if (applications[i - 1].stateRegistration) {
    //               stateRegistration = applications[i - 1].stateRegistration.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //             }
    //
    //             let currentCongressionalDistrict = ''
    //             if (applications[i - 1].currentCongressionalDistrict) {
    //               currentCongressionalDistrict = applications[i - 1].currentCongressionalDistrict.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //             }
    //
    //             let hometown = ''
    //             if (applications[i - 1].hometown) {
    //               hometown = applications[i - 1].hometown.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //             }
    //
    //             let homeCongressionalDistrict = ''
    //             if (applications[i - 1].homeCongressionalDistrict) {
    //               homeCongressionalDistrict = applications[i - 1].homeCongressionalDistrict.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," ").replace(/\n/g," ").replace(/#/g,"")
    //             }
    //
    //             // let tempData2 = csvData[csvData.length - 1]
    //             // tempData2[csvData[0].length - 5] = politicalAlignment
    //             // tempData2[csvData[0].length - 4] = stateRegistration
    //             // tempData2[csvData[0].length - 3] = currentCongressionalDistrict
    //             // tempData2[csvData[0].length - 2] = hometown
    //             // tempData2[csvData[0].length - 1] = homeCongressionalDistrict
    //             // csvData[csvData.length - 1] = tempData2
    //
    //             csvData[csvData.length - 1].push(politicalAlignment, stateRegistration, currentCongressionalDistrict, hometown, homeCongressionalDistrict)
    //           }
    //
    //           if (this.state.org === 'bixel') {
    //             // let tempData2 = csvData[csvData.length - 1]
    //             // csvData[csvData.length - 1] = tempData2.concat(carArray)
    //             // for (let j = 1; j <= this.state.assessments[0].questions.length; j++) {
    //             //
    //             //   if (carArray[j - 1])
    //             //   assessments.push(this.state.assessments[0].questions[i - 1].name)
    //             // }
    //           }
    //
    //           if (applications[i - 1].customAssessmentResults && applications[i - 1].customAssessmentResults.length > 0) {
    //             console.log('Z0')
    //             for (let j = 1; j <= applications[i - 1].customAssessmentResults.length; j++) {
    //               if (applications[i - 1].customAssessmentResults[j - 1]) {
    //                 if (typeof applications[i - 1].customAssessmentResults[j - 1] === 'string') {
    //                   console.log('Z1')
    //
    //                   const result = applications[i - 1].customAssessmentResults[j - 1].replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                   csvData[csvData.length - 1].push(result)
    //
    //                   let questionName = 'Custom Question ' + j
    //                   let showNewCustomResponsesHack = true
    //                   if (showNewCustomResponsesHack && applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults[j - 1]) {
    //                     if (applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                       questionName = 'Q-' + applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                     }
    //                   }
    //                   // if (applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                   //   console.log('show qName: ', applications[i - 1].newCustomAssessmentResults[j - 1].question)
    //                   //   questionName = applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"").substring(0,20) + '...'
    //                   // }
    //
    //                   if (!csvData[0].includes(questionName)) {
    //                     csvData[0].push(questionName)
    //                   }
    //                 } else {
    //                   console.log('Z2')
    //                   const result = applications[i - 1].customAssessmentResults[j - 1].join().replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                   csvData[csvData.length - 1].push(result)
    //                   if (result === undefined || result === null) {
    //                     console.log('result is undefined or null 1')
    //                   }
    //
    //                   const questionName = 'Question ' + j
    //                   if (i === 1 && !csvData[0].includes(questionName)) {
    //                     csvData[0].push(questionName)
    //                   }
    //                 }
    //               } else {
    //                 console.log('Z3')
    //
    //                 csvData[csvData.length - 1].push('N/A')
    //
    //                 let questionName = 'Custom Question ' + j
    //                 let showNewCustomResponsesHack = true
    //                 if (showNewCustomResponsesHack) {
    //                   if (applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                     questionName = 'Q-' + applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                   }
    //
    //                   // if (!applications[i - 1].customAssessmentResults[j - 1]) {
    //                   //   // current bug makes newCustomAssessmentResults skip this
    //                   //
    //                   // } else if (applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults[j - 1]) {
    //                   //
    //                   // }
    //                 }
    //                 // if (applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                 //   console.log('show qName: ', applications[i - 1].newCustomAssessmentResults[j - 1].question)
    //                 //   questionName = applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"").substring(0,20) + '...'
    //                 // }
    //
    //                 if (!csvData[0].includes(questionName)) {
    //                   csvData[0].push(questionName)
    //                 }
    //
    //               }
    //             }
    //           } else if (applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults.length > 0) {
    //
    //             for (let j = 1; j <= applications[i - 1].newCustomAssessmentResults.length; j++) {
    //               if (applications[i - 1].newCustomAssessmentResults[j - 1]) {
    //                 if (typeof applications[i - 1].newCustomAssessmentResults[j - 1].answer === 'string') {
    //                   console.log('Z1')
    //
    //                   const result = applications[i - 1].newCustomAssessmentResults[j - 1].answer.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                   csvData[csvData.length - 1].push(result)
    //
    //                   let questionName = 'Custom Question ' + j
    //                   let showNewCustomResponsesHack = true
    //                   if (showNewCustomResponsesHack && applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults[j - 1]) {
    //                     if (applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                       questionName = 'Q-' + applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                     }
    //                   }
    //                   // if (applications[i - 1].newCustomAssessmentResults && applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                   //   console.log('show qName: ', applications[i - 1].newCustomAssessmentResults[j - 1].question)
    //                   //   questionName = applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"").substring(0,20) + '...'
    //                   // }
    //
    //                   if (!csvData[0].includes(questionName)) {
    //                     csvData[0].push(questionName)
    //                   }
    //                 } else {
    //                   console.log('Z2')
    //                   const result = applications[i - 1].newCustomAssessmentResults[j - 1].answer.join().replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                   csvData[csvData.length - 1].push(result)
    //                   if (result === undefined || result === null) {
    //                     console.log('result is undefined or null 1')
    //                   }
    //
    //                   const questionName = 'Question ' + j
    //                   if (i === 1 && !csvData[0].includes(questionName)) {
    //                     csvData[0].push(questionName)
    //                   }
    //                 }
    //               } else {
    //                 console.log('Z3')
    //
    //                 csvData[csvData.length - 1].push('N/A')
    //
    //                 let questionName = 'Custom Question ' + j
    //                 let showNewCustomResponsesHack = true
    //                 if (showNewCustomResponsesHack) {
    //                   if (applications[i - 1].newCustomAssessmentResults[j - 1] && applications[i - 1].newCustomAssessmentResults[j - 1].question) {
    //                     questionName = 'Q-' + applications[i - 1].newCustomAssessmentResults[j - 1].question.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                   }
    //                 }
    //
    //                 if (!csvData[0].includes(questionName)) {
    //                   csvData[0].push(questionName)
    //                 }
    //
    //               }
    //             }
    //           }
    //
    //           // 3rd party scores - issues with looping
    //           let showScores = false
    //           if (showScores) {
    //             if (applications[i - 1].scores && applications[i - 1].scores.length > 0) {
    //               for (let j = 1; j <= applications[i - 1].scores.length; j++) {
    //                 if (applications[i - 1].scores[j - 1] && applications[i - 1].scores[j - 1].scorer) {
    //
    //                   // tally by suppScores
    //                   if (applications[i - 1].scores[j - 1].suppScores) {
    //                     for (let k = 1; k <= applications[i - 1].scores[j - 1].suppScores.length; k++) {
    //                       // scores[0].scorer.email firstName, lastName, jobTitle, employerName
    //                       // scores[0].suppScores[0].category score
    //
    //                       const result = applications[i - 1].scores[j - 1].suppScores[k - 1].score
    //                       csvData[csvData.length - 1].push(result)
    //
    //                       const category = applications[i - 1].scores[j - 1].suppScores[k - 1].category.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                       const scorerFirstName = applications[i - 1].scores[j - 1].scorer.firstName.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                       const scorerLastName = applications[i - 1].scores[j - 1].scorer.lastName.replace(commaStartingValue,commaReplacementValue).replace(/\r\n/g," | ").replace(/\n/g," | ").replace(/#/g,"")
    //                       const categoryName = category + 'Score by ' + scorerFirstName + ' ' + scorerLastName
    //
    //                       if (!csvData[0].includes(categoryName)) {
    //                         csvData[0].push(categoryName)
    //                       }
    //                     }
    //                   }
    //
    //                 } else {
    //                   console.log('log nothing 4')
    //
    //                 }
    //               }
    //             }
    //           }
    //         }
    //
    //         const reportName = "application_" + selectedApplication.firstName + '_' + selectedApplication.lastName + '_' + selectedWork.title
    //         const returnedData = subExportCSV(reportName,csvData)
    //
    //         // let csvContent = "data:text/csv;charset=utf-8,";
    //         // if (this.state.newCSVMethod) {
    //         //
    //         //   let csvRows = []
    //         //   let headers = csvData[0]
    //         //   csvRows.push(headers.join(','))
    //         //
    //         //   for (const row of csvData) {
    //         //     const values = headers.map((header, index) => {
    //         //
    //         //       if (row[index]) {
    //         //         const escaped = (''+row[index]).replace(/"/g,'\\"')
    //         //         const literalEscaped = `"${escaped}"`
    //         //         console.log('show escaped: ', index, literalEscaped)
    //         //         return literalEscaped
    //         //       } else {
    //         //         console.log('undefined value')
    //         //         const undefinedAlt = " "
    //         //         return undefinedAlt
    //         //       }
    //         //     })
    //         //
    //         //     const newRow = values.join(',')
    //         //     csvRows.push(newRow)
    //         //     csvContent += newRow + "\r\n";
    //         //
    //         //     console.log('show rows: ', csvContent)
    //         //   }
    //         //
    //         //   // csvContent = csvRows.join('\n')
    //         //   // console.log('show rows: ', csvContent)
    //         //
    //         // } else {
    //         //   csvData.forEach(function(rowArray){
    //         //      let row = rowArray.join(",");
    //         //      csvContent += row + "\r\n";
    //         //   });
    //         // }
    //         //
    //         // let reportName = this.state.selectedReportShortname + '-report.csv'
    //         //
    //         // const encodedUri = encodeURI(csvContent);
    //         // const link = document.createElement("a");
    //         // link.setAttribute("href", encodedUri);
    //         // link.setAttribute("download", reportName);
    //         // document.body.appendChild(link); // Required for FF
    //         // link.click();
    //         // document.body.removeChild(link);
    //         //
    //         // this.setState({ isLoading: false })
    //
    //       } else {
    //         this.setState({ clientErrorMessage: 'There is no data to export', isLoading: false})
    //       }
    //
    //     } else {
    //       console.log('there was a reporting error', response.data.message)
    //       this.setState({ clientErrorMessage, isLoading: false})
    //     }
    //
    // }).catch((error) => {
    //     console.log('Reporting query did not work', error);
    //
    //     if (error && error.message) {
    //       clientErrorMessage = error.message.toString()
    //     }
    //
    //     this.setState({ clientErrorMessage, isLoading: false})
    // });
  }

  renderAllocation() {
    console.log('renderAllocation called')

    let rows = []

    let weights = [
      { name: 'Work Preferences', description: 'Candidates interested in relevant industries and employer attributes are awarded maximum points.', ref: 'preferencesPercent', value: this.state.preferencesPercent, ref2: 'preferences' },
      { name: 'Work Interests', description: 'Candidates interested in careers that require relevant skills are awarded maximum points.', ref: 'interestsPercent', value: this.state.interestsPercent, ref2: 'interests' },
      { name: 'Personality', description: 'Candidates whose personality most matches the sought after type are awarded maximum points.', ref: 'traitsPercent', value: this.state.traitsPercent, ref2: 'traits' },
      { name: 'Values', description: 'Candidates whose values match your preferences are awarded maximum points.', ref: 'valuesPercent', value: this.state.valuesPercent, ref2: 'values' },
      { name: 'Skills', description: 'Candidates who self-assess for the relevant skills are awarded maximum points.', ref: 'skillsPercent', value: this.state.skillsPercent, ref2: 'skills' },
      { name: 'Endorsements', description: 'Candidates with high skill/trait endorsement ratings from close, experts are awarded maximum points.', ref: 'endorsementsPercent', value: this.state.endorsementsPercent, ref2: 'endorsements' },
      { name: 'Education', description: 'Candidates with the target level and focus of education are awarded maximum points.', ref: 'educationPercent', value: this.state.educationPercent, ref2: 'education' },
      { name: 'Projects', description: 'Candidates with 1+ years working on projects building relevant skills are awarded maximum points.', ref: 'projectsPercent', value: this.state.projectsPercent, ref2: 'projects' },
      { name: 'Experience', description: 'Candidates who have 1+ years of paid expereience building relevant skills are awarded maximum points.', ref: 'experiencePercent', value: this.state.experiencePercent, ref2: 'experience' },
      { name: 'Interview', description: 'Candidates who perform well on the Bixel Exchange interview are awarded maximum points.', ref: 'interviewPercent', value: this.state.interviewPercent, ref2: 'interview' },
      { name: 'Diversity', description: 'Candidates who are in bring diversity or showcase unique adversity are awarded maximum points.', ref: 'adversityScorePercent', value: this.state.adversityScorePercent, ref2: 'adversityScore' },
    ]

    if (this.state.thirdPartyAssessmentPercent) {
      // console.log('show it: ', this.state.thirdPartyAssessmentPercent)
      const thirdPartyAssessmentWeight = { name: 'Third Party Assessments', description: 'Candidates who complete the third party assessments at a satisfactory level are awarded maximum points.', ref: 'thirdPartyAssessmentPercent', value: this.state.thirdPartyAssessmentPercent, ref2: 'thirdPartyAssessments' }
      weights.splice(5,0,thirdPartyAssessmentWeight)
    }

    if (this.state.coverLetterPercent) {
      const coverLetterWeight = { name: 'Cover Letter', description: 'Candidates who have strong cover letter are awarded maximum points.', ref: 'coverLetterPercent', value: this.state.coverLetterPercent, ref2: 'coverLetter' }
      weights.splice(9,0,coverLetterWeight)
    }

    if (this.state.resumePercent) {
      const resumeWeight = { name: 'Resume', description: 'Candidates who have strong resumes are awarded maximum points.', ref: 'resumePercent', value: this.state.resumePercent, ref2: 'resume' }
      weights.splice(9,0,resumeWeight)
    }

    for (let i = 1; i <= weights.length; i++) {
        console.log('iterate: ', i)

      if (this.props.activeOrg !== 'c2c' && weights[i - 1].name === 'Political Preference') {
        // do no render
      } else {

        rows.push(
          <div key={"weights|" + i}>
            <div>
              <div className="relative-column-85">
                <p className="half-bold-text">{i}. {weights[i - 1].name}</p>
                <div className="half-spacer" />
                <p className="description-text-3">{weights[i - 1].description}</p>
              </div>

              {(this.props.source === 'Employer|Edit') ? (
                <div className="relative-column-15 right-text">
                  <div className="calc-column-offset-30">
                    <input type="number" className="number-field heading-text-2 cta-color bold-text right-text" min="0" max="100" placeholder="0" name={weights[i - 1].ref} value={weights[i - 1].value} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="fixed-column-30">
                    <div className="mini-spacer"/><div className="mini-spacer"/>
                    <p className="heading-text-2 cta-color bold-text">%</p>
                  </div>
                </div>
              ):(
                <div className="relative-column-15 right-text">
                  <p className="heading-text-2 cta-color bold-text">{this.calculateBenchmarkWeight(weights[i - 1].ref2)}%</p>
                </div>
              )}

              <div className="clear" />
              <div className="spacer"/><div className="half-spacer"/>
            </div>
          </div>
        )
      }
    }

    return rows

  }

  configureBenchmarkWeights(benchmark) {
    console.log('configureBenchmarkWeights')

    const denominator = this.calculateBenchmarkWeight(null,'denominator')
    console.log('yeah?', denominator)
    if (denominator || denominator === 0) {
      console.log('show denominator: ', denominator)

      //preferences
      let preferencesPercent = 0
      if (benchmark.workPreferenceWeight) {
        preferencesPercent = benchmark.workPreferenceWeight
      }

      //interests
      let interestsPercent = 0
      if (benchmark.interestsWeight) {
        interestsPercent = benchmark.interestsWeight
      } else if (benchmark.interests) {
        for (let i = 1; i <= benchmark.interests.length; i++) {
          if (benchmark.interests[i - 1].weight) {
            interestsPercent = interestsPercent + Number(benchmark.interests[i - 1].weight)
          }
        }
      }

      //traits
      let traitsPercent = 0
      if (benchmark.personalityWeight) {
        traitsPercent = benchmark.personalityWeight
      } else if (benchmark.traits) {
        for (let i = 1; i <= benchmark.traits.length; i++) {
          if (benchmark.traits[i - 1].weight) {
            traitsPercent = traitsPercent + Number(benchmark.traits[i - 1].weight)
          }
        }
      }

      //endorsements
      let valuesPercent = 0
      if (benchmark.valuesWeight) {
        valuesPercent = benchmark.valuesWeight
      }

      //skills
      let skillsPercent = 0

      let benchmarkHardSkills = []
      let benchmarkSoftSkills = []

      if (benchmark.skills && benchmark.skills.length > 0) {
        for (let i = 1; i <= benchmark.skills.length; i++) {
          if (benchmark.skills[i - 1].weight) {
            skillsPercent = skillsPercent + Number(benchmark.skills[i - 1].weight)

            if (benchmark.skills[i - 1].skillType === 'Hard Skill') {
              benchmarkHardSkills.push(benchmark.skills[i - 1].title)
            } else {
              benchmarkSoftSkills.push(benchmark.skills[i - 1].title)
            }
          }
        }
      } else if (benchmark.skillsWeight) {
        skillsPercent = benchmark.skillsWeight
      }

      let thirdPartyAssessmentPercent = 0
      if (benchmark.thirdPartyAssessmentWeight) {
        thirdPartyAssessmentPercent = benchmark.thirdPartyAssessmentWeight
      }

      //endorsements
      let endorsementsPercent = 0
      if (benchmark.endorsementWeight) {
        endorsementsPercent = benchmark.endorsementWeight
      }

      //education
      let educationPercent = 0
      if (benchmark.educationWeight) {
        educationPercent = benchmark.educationWeight
      }

      //projects
      let projectsPercent = 0
      if (benchmark.projectWeight) {
        projectsPercent = benchmark.projectWeight
      }

      //experience
      let experiencePercent = 0
      if (benchmark.experienceWeight) {
        experiencePercent = benchmark.experienceWeight
      }

      //interview
      let interviewPercent = 0
      if (benchmark.interview) {
        interviewPercent = benchmark.interview.weight
      }

      let politicalPercent = 0
      let homeStatePercent = 0
      let adversityScorePercent = 0
      if (this.props.activeOrg === 'c2c') {

        if (benchmark.politicalParties) {
          for (let i = 1; i <= benchmark.politicalParties.length; i++) {
            if (benchmark.politicalParties[i - 1].weight) {
              politicalPercent = politicalPercent + Number(benchmark.politicalParties[i - 1].weight)
            }
          }
        }

        if (benchmark.hometownWeight) {
          homeStatePercent = benchmark.hometownWeight
        }
      }

      if (benchmark.adversityScoreWeight) {
        adversityScorePercent = benchmark.adversityScoreWeight
      }

      let selectedApplication = this.props.selectedApplication
      if (this.props.selectedJob) {
        if (selectedApplication.workPreferenceResults) {
          selectedApplication['workPreferenceResults'][0] = this.props.selectedJob.workFunction
        }
      }

      // // interests
      // let generalInterests = []
      // if (benchmark.generalInterests) {
      //   generalInterests = benchmark.generalInterests
      // }
      //
      // // education
      // let degreeRequirements = ''
      // if (benchmark.degreeRequirements) {
      //   degreeRequirements = benchmark.degreeRequirements
      // }
      //
      // let idealMajors = ''
      // if (benchmark.idealMajors) {
      //   idealMajors = benchmark.idealMajors
      // }
      //
      // let gpaRange = ''
      // if (benchmark.gpRange) {
      //   gpaRange = benchmark.gpaRange
      // }
      //
      // let gradYearRange = ''
      // if (benchmark.gradYearRange) {
      //   gradYearRange = benchmark.gradYearRange
      // }
      //
      // let testScores = ''
      // if (benchmark.testScores) {
      //   testScores = benchmark.testScores
      // }
      //
      // let courseHours = ''
      // if (benchmark.courseHours) {
      //   courseHours = benchmark.courseHours
      // }
      //
      // let courses = []
      // if (benchmark.courses) {
      //   courses = benchmark.courses
      // }
      //
      // let certifications = []
      // if (benchmark.certifications) {
      //   certifications = benchmark.certifications
      // }
      //
      // // projects and experience
      // let experienceTags = []
      // if (benchmark.experienceTags) {
      //   experienceTags = benchmark.experienceTags
      // }
      //
      // let projectTags = []
      // if (benchmark.projectTags) {
      //   projectTags = benchmark.projectTags
      // }
      //
      // let volunteerTags = []
      // if (benchmark.volunteerTags) {
      //   volunteerTags = benchmark.volunteerTags
      // }
      //
      // // interview
      // let interviewQuestions = []
      // if (benchmark.interviewQuestions) {
      //   interviewQuestions = benchmark.interviewQuestions
      // }
      //
      // let strongFitCues = ''
      // if (benchmark.strongFitCues) {
      //   strongFitCues = benchmark.strongFitCues
      // }
      //
      // let poorFitCues = ''
      // if (benchmark.poorFitCues) {
      //   poorFitCues = benchmark.poorFitCues
      // }
      //
      // // diversity
      // let gender = ''
      // if (benchmark.gender) {
      //   gender = benchmark.gender
      // }
      //
      // let race = ''
      // if (benchmark.race) {
      //   race = benchmark.race
      // }
      //
      // let veteran = ''
      // if (benchmark.veteran) {
      //   veteran = benchmark.veteran
      // }
      //
      // let lowIncome = ''
      // if (benchmark.lowIncome) {
      //   lowIncome = benchmark.lowIncome
      // }
      //
      // let fosterYouth = ''
      // if (benchmark.fosterYouth) {
      //   fosterYouth = benchmark.fosterYouth
      // }
      //
      // let homeless = ''
      // if (benchmark.homeless) {
      //   homeless = benchmark.homeless
      // }
      //
      // let incarcerated = ''
      // if (benchmark.incarcerated) {
      //   incarcerated = benchmark.incarcerated
      // }
      //
      // let lgbtqia = ''
      // if (benchmark.lgbtqia) {
      //   lgbtqia = benchmark.lgbtqia
      // }
      //
      // let disability = ''
      // if (benchmark.disability) {
      //   disability = benchmark.disability
      // }
      //
      // let firstGenImmigrant = ''
      // if (benchmark.firstGenImmigrant) {
      //   firstGenImmigrant = benchmark.firstGenImmigrant
      // }
      //
      // let firstGenCollegeStudent = ''
      // if (benchmark.firstGenCollegeStudent) {
      //   firstGenCollegeStudent = benchmark.firstGenCollegeStudent
      // }

      // console.log('final run: ', thirdPartyAssessmentPercent)

      this.setState({ preferencesPercent, interestsPercent, traitsPercent, valuesPercent, skillsPercent, thirdPartyAssessmentPercent,
        endorsementsPercent, educationPercent, projectsPercent, experiencePercent, interviewPercent, politicalPercent,
        homeStatePercent, adversityScorePercent, benchmarkHardSkills, benchmarkSoftSkills, selectedApplication, benchmark,

        // generalInterests, experienceTags, projectTags, volunteerTags,
        // degreeRequirements, idealMajors, gpaRange, gradYearRange, testScores, courseHours, courses, certifications,
        // interviewQuestions, strongFitCues, poorFitCues,
        // gender, race, veteran, lowIncome, fosterYouth, homeless, incarcerated, lgbtqia, disability, firstGenImmigrant, firstGenCollegeStudent,

      })
    }
  }

  calculateBenchmarkWeight(type, subType) {
    console.log('calculateBenchmarkWeight ')

    let numerator = 0
    let denominator = 0

    let benchmark = this.state.benchmark
    if (this.state.selectedJob.postType === 'Track' || this.state.selectedJob.subPostType === 'Track') {
      benchmark = this.props.trackBenchmark
    } else if (this.props.benchmark) {
      benchmark = this.props.benchmark
    }

    if (benchmark) {
      console.log('in benchmark: ', benchmark)
      //preferences
      if (benchmark.workPreferenceWeight) {
        denominator = denominator + benchmark.workPreferenceWeight
        if (type === 'preferences') {
          numerator = numerator + benchmark.workPreferenceWeight
        }
      }

      //interests
      if (benchmark.interests) {
        for (let i = 1; i <= benchmark.interests.length; i++) {
          if (benchmark.interests[i - 1].weight) {
            denominator = denominator + Number(benchmark.interests[i - 1].weight)
            if (type === 'interests') {
              numerator = numerator + Number(benchmark.interests[i - 1].weight)
            }
          }
        }
      }

      //traits
      if (benchmark.traits) {
        for (let i = 1; i <= benchmark.traits.length; i++) {
          if (benchmark.traits[i - 1].weight) {
            denominator = denominator + Number(benchmark.traits[i - 1].weight)
            if (type === 'traits') {
              numerator = numerator + Number(benchmark.traits[i - 1].weight)
            }
          }
        }
      }

      //values
      if (benchmark.valuesWeight) {
        denominator = denominator + benchmark.valuesWeight
        if (type === 'values') {
          numerator = numerator + benchmark.valuesWeight
        }
      }

      //skills
      if (benchmark.skills) {
        for (let i = 1; i <= benchmark.skills.length; i++) {
          if (benchmark.skills[i - 1].weight) {
            denominator = denominator + Number(benchmark.skills[i - 1].weight)
            if (type === 'skills') {
              numerator = numerator + Number(benchmark.skills[i - 1].weight)
            }
          }
        }
      }

      //endorsements
      if (benchmark.thirdPartyAssessmentWeight) {
        denominator = denominator + benchmark.thirdPartyAssessmentWeight
        if (type === 'thirdPartyAssessments') {
          numerator = numerator + benchmark.thirdPartyAssessmentWeight
        }
      }

      //endorsements
      if (benchmark.endorsementWeight) {
        denominator = denominator + benchmark.endorsementWeight
        if (type === 'endorsements') {
          numerator = numerator + benchmark.endorsementWeight
        }
      }

      //education
      if (benchmark.educationWeight) {
        denominator = denominator + benchmark.educationWeight
        if (type === 'education') {
          numerator = numerator + benchmark.educationWeight
        }
      }

      //projects
      if (benchmark.projectWeight) {
        denominator = denominator + benchmark.projectWeight
        if (type === 'projects') {
          numerator = numerator + benchmark.projectWeight
        }
      }

      //experience
      if (benchmark.experienceWeight) {
        denominator = denominator + benchmark.experienceWeight
        if (type === 'experience') {
          numerator = numerator + benchmark.experienceWeight
        }
      }

      //interview
      if (benchmark.interview) {
        denominator = denominator + benchmark.interview.weight
        if (type === 'interview') {
          numerator = numerator + benchmark.interview.weight
        }
      }

      if (this.props.activeOrg === 'c2c') {

        if (benchmark.politicalParties) {
          for (let i = 1; i <= benchmark.politicalParties.length; i++) {
            if (benchmark.politicalParties[i - 1].weight) {
              denominator = denominator + Number(benchmark.politicalParties[i - 1].weight)
              if (type === 'politicalPreference') {
                numerator = numerator + Number(benchmark.politicalParties[i - 1].weight)
              }
            }
          }
        }

        if (benchmark.hometownWeight) {
          denominator = denominator + benchmark.hometownWeight
          if (type === 'homeState') {
            numerator = numerator + benchmark.hometownWeight
          }
        }

        if (benchmark.adversityScoreWeight) {
          denominator = denominator + benchmark.adversityScoreWeight
          if (type === 'adversityScore') {
            numerator = numerator + benchmark.adversityScoreWeight
          }
        }

      }
    }

    let weight = ((numerator / denominator) * 100).toFixed()

    console.log('show output: ', numerator, denominator, weight)

    if (subType === 'denominator') {
      return denominator
    } else {
      return weight
    }
  }


  render() {

    let subPostType = ''
    if (this.state.selectedJob) {
      subPostType = this.state.selectedJob.postType
      console.log('2er', subPostType, this.state.selectedJob.postType)
      if (this.state.selectedJob.subPostType) {
        console.log('3er')
        subPostType = this.state.selectedJob.subPostType
      }
    }

    const workApp = this.state.selectedApplication

    return (
        <div>
          {(this.state.showModule) ? (
            <div>
              {(workApp) && (
                <div>
                  <div className="full-width">
                    <div className={(window.innerWidth > 768) ? "relative-column-75 padding-five-percent-left" : ""}>
                      <div className={(window.innerWidth > 768) ? "card-clear-padding slightly-rounded-corners full-width max-width-1400 top-margin-40 pin-right" : ""}>
                        {(window.innerWidth > 768) && (
                          <div className="full-width height-5 dark-background" />
                        )}

                        <div className="padding-30">
                          <div className="top-padding">
                            <Link className="background-button calc-column-offset-70" target="_blank" to={"/organizations/" + this.state.org + "/members/" + workApp.username}>
                              <div className="fixed-column-90">
                                <img src={(workApp.pictureURL) ? workApp.pictureURL : profileIconDark} alt="GC" className="profile-thumbnail-70" />
                              </div>
                              <div className="calc-column-offset-90">
                                <p className="heading-text-2">{workApp.firstName} {workApp.lastName}</p>
                                <p className="top-padding-5 standard-color">{workApp.email}{(workApp.phoneNumber) && " | " + workApp.phoneNumber}</p>
                              </div>
                              <div className="clear" />
                            </Link>

                            <div className="fixed-column-70">
                              <button className="background-button full-space" onClick={() => this.setState({ modalIsOpen: true, showMatchScore: true })}>
                                {(workApp.match) && (
                                  <CircularProgressbar
                                    value={workApp.match}
                                    text={`${workApp.match}%`}
                                    styles={{
                                      path: { stroke: `${'primaryColor'}, ${workApp.match}` },
                                      text: { fill: '#1F82CC', fontSize: '24px' },
                                      trail: { stroke: 'transparent' }
                                    }}
                                  />
                                )}
                              </button>
                            </div>
                            <div className="clear" />
                          </div>

                          <div className="top-margin">
                            <div className="doc-links">
                              <ul>
                                {this.state.selectedApplication.videoResumeURL && <li><a target="_blank" href={this.state.selectedApplication.videoResumeURL}><img src={videoIconDark} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">VID</p>}</a></li> }
                                {this.state.selectedApplication.resumeURL && <li><a target="_blank" href={this.state.selectedApplication.resumeURL}><img src={resumeIconDark} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">RES</p>}</a></li> }
                                {this.state.selectedApplication.coverLetterURL && <li><a target="_blank" href={this.state.selectedApplication.coverLetterURL}><img src={coverLetterIconDark} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">CL</p>}</a></li> }
                                {this.state.selectedApplication.customWebsiteURL && <li><a target="_blank" href={this.state.selectedApplication.customWebsiteURL}><img src={websiteIconDark} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">PORT</p>}</a></li> }
                                {this.state.selectedApplication.linkedInURL && <li><a target="_blank" href={this.state.selectedApplication.linkedInURL}><img src={linkedinIconDark} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">LNK</p>}</a></li> }
                                {this.state.selectedApplication.letterOfRecommendationURL && <li><a target="_blank" href={this.state.selectedApplication.letterOfRecommendationURL}><img src={letterOfRecIcon} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">LOR</p>}</a></li> }
                                {(this.state.selectedApplication.transcriptURL && this.props.source === 'Organization') && <li><a target="_blank" href={this.state.selectedApplication.transcriptURL}><img src={transcriptIcon} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">TRS</p>}</a></li> }
                                {(this.state.selectedApplication.identificationURL && this.props.source === 'Organization') && <li><a target="_blank" href={this.state.selectedApplication.identificationURL}><img src={idIcon} alt="GC" className="image-25-fit"/>{(this.state.includeIconLabels) && <p className="description-text-5 standard-color top-padding-5 center-text">ID</p>}</a></li> }
                              </ul>
                            </div>
                          </div>

                          <div className="top-margin-20">
                            <div className="row-10">
                              <p className="heading-text-3">Basic Application Information</p>

                              <div className="row-10 description-text-2">
                                {(workApp.postingTitle) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Posting Title</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.postingTitle}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.postingTitle) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>{(this.state.selectedJob && this.state.selectedJob.postType === 'Program') ? "Training Provider" : "Employer Name"}</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {(this.state.selectedJob && this.state.selectedJob.employerURL && this.state.selectedJob.employerName === workApp.postingEmployerName) ? (
                                        <a href={this.state.selectedJob.employerURL} target="_blank" rel="noopener noreferrer">{workApp.postingEmployerName}</a>
                                      ) : (
                                        <p>{workApp.postingEmployerName}</p>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.createdAt) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Submission Date</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{convertDateToString(new Date(workApp.createdAt),'date-2')}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.updatedAt && workApp.createdAt !== workApp.updatedAt) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Last Updated</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{convertDateToString(new Date(workApp.updatedAt),'date-2')}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.stage) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Stage</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.stage}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                              </div>

                            </div>

                            <div className="row-10">
                              <p className="heading-text-3">Summary</p>

                              <div className="row-10 description-text-2">
                                {(workApp.match && workApp.totalHours) ? (
                                  <div>
                                    <div className="relative-column-20 standard-border padding-10 center-text">
                                      <p className="description-text-color description-text-2 bold-text">Match Score</p>
                                      <p className="top-padding-5">{workApp.match}%</p>
                                    </div>
                                    <div className="relative-column-20 standard-border padding-10 center-text">
                                      <p className="description-text-color description-text-2 bold-text">Total Work Hours</p>
                                      <p className="top-padding-5">{workApp.totalHours}</p>
                                    </div>
                                    <div className="relative-column-20 standard-border padding-10 center-text">
                                      <p className="description-text-color description-text-2 bold-text">Paid Experience Hours</p>
                                      <p className="top-padding-5">{workApp.experienceHours}</p>
                                    </div>
                                    <div className="relative-column-20 standard-border padding-10 center-text">
                                      <p className="description-text-color description-text-2 bold-text">Project Hours</p>
                                      <p className="top-padding-5">{workApp.projectHours}</p>
                                    </div>
                                    <div className="relative-column-20 standard-border padding-10 center-text">
                                      <p className="description-text-color description-text-2 bold-text">Volunteer Hours</p>
                                      <p className="top-padding-5">{workApp.volunteerHours}</p>
                                    </div>

                                    <div className="clear" />
                                  </div>
                                ) : (
                                  <div />
                                )}
                                <div className="standard-border">
                                  <div className="fixed-column-160 padding-10 bold-text">
                                    <p>Referral</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    {(workApp.referralCode && this.state.referralDetails) ? (
                                      <div>
                                        <p><label className="bold-text">Referrer Name</label>: {this.state.referralDetails.referrerFirstName} {this.state.referralDetails.referrerLastName}</p>
                                        {(this.state.referralDetails.referrerPartnerOrg) && (
                                          <p className="top-margin-20"><label className="bold-text">Referrer Org</label>: {this.state.referralDetails.referrerPartnerOrg}</p>
                                        )}
                                        <p className="top-margin-20"><label className="bold-text">Date of Referral</label>: {convertDateToString(new Date(this.state.referralDetails.createdAt),'date-2')}</p>
                                        <p className="top-margin-20"><label className="bold-text">Reason</label>: {this.state.referralDetails.reason}</p>
                                      </div>
                                    ) : (
                                      <p> - </p>
                                    )}
                                  </div>
                                  <div className="clear" />
                                </div>
                                <div className="standard-border">
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Competency Endorsements</p>
                                  </div>
                                  <div className="calc-column-offset-160 padding-10">
                                    {(workApp.endorsements && workApp.endorsements.length > 0) ? (
                                      <p>{workApp.firstName} received {workApp.endorsements.length} endorsements on relevant competencies</p>
                                    ) : (
                                      <p> - </p>
                                    )}
                                  </div>
                                  <div className="clear" />
                                </div>
                              </div>
                            </div>

                            <div className="row-10">
                              <p className="heading-text-3">Details</p>

                              <div className="row-10 description-text-2">
                                {(workApp.educationStatus) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Education Status</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.educationStatus}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.education && workApp.education.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Education</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.education.map((item, optionIndex) =>
                                        <div key={"education|" + optionIndex} className="">
                                          <div className="bottom-margin-15">
                                            <p className="">{optionIndex + 1}. {item.name}</p>
                                            <p className="description-text-1 top-padding-5">{item.degree}{(item.major) && " - " + item.major}{(item.location) && " - " + item.location}</p>
                                            <p className="description-text-2 description-text-color top-padding-5">{(item.startDate) && item.startDate}{(item.isContinual) ? " - Still Attending" : " - " + item.endDate}</p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.experience && workApp.experience.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Experience</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.experience.map((item, optionIndex) =>
                                        <div key={"experience|" + optionIndex} className="">
                                          <div className="bottom-margin-15">
                                            <p className="">{optionIndex + 1}. {item.jobTitle}{(item.employerName) && "@ " + item.employerName}</p>
                                            <p className="description-text-1 top-padding-5">{item.jobFunction}{(item.industry) && " - " + item.industry}{(item.location) && " - " + item.location}</p>
                                            <p className="description-text-2 description-text-color top-padding-5">{(item.startDate) && item.startDate}{(item.isContinual) ? " - Still Attending" : " - " + item.endDate}{(item.hoursPerWeek) && " | " + item.hoursPerWeek} Per Week</p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.projects && workApp.projects.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Projects</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.projects.map((item, optionIndex) =>
                                        <div key={"project|" + optionIndex} className="">
                                          <div className="bottom-margin-15">
                                            <p className="">{optionIndex + 1}. {item.name}</p>
                                            <p className="description-text-1 top-padding-5">{item.category}{(item.hours) && " - " + item.hours + " hours"}{(item.collaborators && item.collaborators.length > 0) && " - " + item.collaborators.length}</p>
                                            {(item.url) && (
                                              <a href={item.url} target="_blank" rel="noopener noreferrer" className="description-text-2 top-padding-5">Link to Project</a>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.extras && workApp.extras.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Extracurriculars & Awards</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.extras.map((item, optionIndex) =>
                                        <div key={"extra|" + optionIndex} className="">
                                          <div className="bottom-margin-15">
                                            <p className="">{optionIndex + 1}. {(item.activityName) ? item.activityName : item.name}</p>
                                            {(item.roleName) && (
                                              <p className="description-text-1 top-padding-5">{item.roleName}</p>
                                            )}
                                            <p className="description-text-2 description-text-color top-padding-5">{(item.awardDate) ? item.awardDate : (item.startDate) && (item.isContinual) ? item.startDate + " - Still Active" : item.startDate + " - " + item.endDate}{(item.hoursPerWeek) && " - " + item.hoursPerWeek + " per Week"}</p>
                                            {(item.description) && (
                                              <p className="description-text-2 description-text-color top-padding-5">{item.description}</p>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row-10">
                              <p className="heading-text-3">Career Assessment Information</p>

                              <div className="row-10 description-text-2">
                                {(workApp.workPreferenceResults && workApp.workPreferenceResults.length > 1) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Work Preferences</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.workPreferenceResults.map((item, optionIndex) =>
                                        <div key={"wp|" + optionIndex} className="">
                                          {(this.state.wpQuestions[optionIndex] && item) && (
                                            <div className="bottom-margin-15">
                                              <p className="description-text-2 description-text-color">{optionIndex + 1}. {this.state.wpQuestions[optionIndex].name}</p>
                                              <p className="description-text-1 top-padding-5">{item.replace("[", "").replace("]", "").replace(/"/g,"")}</p>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}

                                {(workApp.interestResults && workApp.interestResults.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Interests</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.interestResults.map((item, optionIndex) =>
                                        <div key={"workInterest|" + optionIndex} className="bottom-margin-15">
                                          <p><label className="bold-text">{item.name}</label>: {((item.score / 40) * 100).toString()}% interested in {item.name.toLowerCase()} careers</p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}

                                {(workApp.personalityResults && workApp.personalityResults.myersBriggs && workApp.personalityResults.fiveFactors) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Personality</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p className="bottom-margin-15"><label className="bold-text">Myers Briggs</label>: {workApp.personalityResults.myersBriggs}</p>
                                      <p className="bottom-margin-15"><label className="bold-text">Openness</label>: {((workApp.personalityResults.fiveFactors.opennessScore / 16) * 100)}% percentile in openness to experience (five factor model)</p>
                                      <p className="bottom-margin-15"><label className="bold-text">Conscientiousness</label>: {((workApp.personalityResults.fiveFactors.conscientiousnessScore / 16) * 100)}% percentile in conscientiousness (five factor model)</p>
                                      <p className="bottom-margin-15"><label className="bold-text">Extraversion</label>: {((workApp.personalityResults.fiveFactors.extraversionScore / 16) * 100)}% percentile in extraversion (five factor model)</p>
                                      <p className="bottom-margin-15"><label className="bold-text">Agreeablenss</label>: {((workApp.personalityResults.fiveFactors.agreeablenessScore / 16) * 100)}% percentile in agreeableness (five factor model)</p>
                                      <p className="bottom-margin-15"><label className="bold-text">Neuroticism</label>: {((workApp.personalityResults.fiveFactors.neuroticismScore / 16) * 100)}% percentile in neuroticism (five factor model)</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}

                                {(workApp.topGravitateValues && workApp.topGravitateValues.length > 0 && workApp.topEmployerValues && workApp.topEmployerValues.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Values</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p className="bottom-margin-15">{this.configureValuesText('gravitateValues', workApp.topGravitateValues)}</p>
                                      <p>{this.configureValuesText('employerValues', workApp.topEmployerValues)}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}

                                {(workApp.newSkillAnswers && workApp.newSkillAnswers.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Skills (Self-Assessed)</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      {workApp.newSkillAnswers.map((item, optionIndex) =>
                                        <span key={"skills|" + optionIndex}>
                                          {(optionIndex < 10) && (
                                            <div key={"skills|" + optionIndex} className="float-left right-margin bottom-margin">
                                              <div className="tag-container-basic dark-background white-text">
                                                <p>{item.name}</p>
                                              </div>
                                            </div>
                                          )}
                                        </span>
                                      )}
                                      <div className="clear" />
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row-10">
                              <p className="heading-text-3">Demographic Information</p>

                              <div className="row-10 description-text-2">
                                {(workApp.dateOfBirth) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Birth Date</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.dateOfBirth}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.address) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Address</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.address}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.city) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>City</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.city}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.zipcode) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Zip Code</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.zipcode}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.races && workApp.races.length > 0) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Races</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.races.join()}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.selfDescribedRace) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Self-Described Race</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.selfDescribedRace}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.gender) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Gender</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.gender}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.veteran) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Veteran</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.veteran}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.workAuthorization) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Work AuthRoutes</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.workAuthorization}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.numberOfMembers) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Number of Members in Household</p>
                                    </div>
                                    <div className="calc-column-offset-160 padding-10">
                                      <p>{workApp.numberOfMembers}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.householdIncome) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Household Income</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.householdIncome}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.fosterYouth) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Foster Youth</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.fosterYouth}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.homeless) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Homeless</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.homeless}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.incarcerated) && (
                                  <div>
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Incarcerated</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.incarcerated}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(workApp.adversityList && workApp.adversityList.length > 0) && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 padding-10 bold-text">
                                      <p>Background Info</p>
                                    </div>
                                    <div className="calc-column-offset-160 standard-border padding-10">
                                      <p>{workApp.adversityList.join()}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                              </div>
                            </div>

                            {(workApp.newCustomAssessmentResults && workApp.newCustomAssessmentResults.length > 0) && (
                              <div className="row-10">
                                <p className="heading-text-3">Custom Survey Answers</p>

                                <div className="row-10 description-text-2">
                                  {(workApp.educationStatus) && (
                                    <div className="standard-border">
                                      <div className="fixed-column-160 padding-10 bold-text">
                                        <p>Answers to Custom Survey</p>
                                      </div>
                                      <div className="calc-column-offset-160 standard-border padding-10">
                                        {workApp.newCustomAssessmentResults.map((item, optionIndex) =>
                                          <div key={"ca|" + optionIndex} className="">
                                            {(item) && (
                                              <div className="bottom-margin-15">
                                                <p className="description-text-2 description-text-color">{optionIndex + 1}. {item.question}</p>
                                                <p className="description-text-1 top-padding-5">{item.answer}</p>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            <div className="row-10">
                              <p className="heading-text-3">Notes & Meta Information</p>

                              <div className="row-10 description-text-2">
                                <div className="standard-border">
                                  <div className="fixed-column-160 padding-10 bold-text">
                                    <p>Notes</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    <p>{(workApp.notes) ? workApp.notes : " - "}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                                <div>
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Interview Score</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    <p>{(workApp.interview) ? workApp.interview.score + ' by ' + workApp.interview.interviewerName + ' on ' + workApp.interview.date : ' - '}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                                <div className="standard-border">
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Feedback to Share With Candidate</p>
                                  </div>
                                  <div className="calc-column-offset-160 padding-10">
                                    <p>{(workApp.feedback) ? workApp.feedback : ' - '}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                                {(this.state.selectedJob && this.state.selectedJob.postType !== 'Program') && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Feedback from Employer</p>
                                    </div>
                                    <div className="calc-column-offset-160 padding-10">
                                      <p>{(workApp.employerFeedback) ? workApp.employerFeedback : ' - '}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                {(this.state.selectedJob && this.state.selectedJob.postType !== 'Program') && (
                                  <div className="standard-border">
                                    <div className="fixed-column-160 standard-border padding-10 bold-text">
                                      <p>Messsage to Employer</p>
                                    </div>
                                    <div className="calc-column-offset-160 padding-10">
                                      <p>{(workApp.employerMessage) ? workApp.employerMessage : ' - '}</p>
                                    </div>
                                    <div className="clear" />
                                  </div>
                                )}
                                <div className="standard-border">
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Subsidy Eligibility</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    <p>{(workApp.isSubsidyEligible) ? "Yes" : "No"}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                                <div className="standard-border">
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Is Workforce Ready</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    <p>{(workApp.isWorkforceReady) ? "Yes" : "No"}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                                <div className="standard-border">
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Assigned Staff</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    <p>{(workApp.assignedStaff && workApp.assignedStaff[0]) ? workApp.assignedStaff[0].firstName + ' ' + workApp.assignedStaff[0].lastName : "Not Assigned"}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                                <div className="standard-border">
                                  <div className="fixed-column-160 standard-border padding-10 bold-text">
                                    <p>Assigned Scorer</p>
                                  </div>
                                  <div className="calc-column-offset-160 standard-border padding-10">
                                    <p>{(workApp.scorers && workApp.scorers[0]) ? workApp.scorers[0].firstName + ' ' + workApp.scorers[0].lastName : "Not Assigned"}</p>
                                  </div>
                                  <div className="clear" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {(window.innerWidth > 768) && (
                      <div className="relative-column-25 horizontal-padding top-margin-40">
                        <div className="left-padding-20">
                          <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                            <div className="full-width height-5 senary-background" />
                            <div className="padding-20">
                              <p className="heading-text-5">Actions</p>

                              <div className="half-spacer" />

                              <div className="row-10">
                                <button onClick={() => this.setState({ modalIsOpen: true, showEditView: true })} className="background-button full-width left-text cta-color row-15">
                                  <div className="fixed-column-35">
                                    <img src={editIconDark} alt="GC" className="image-20-fit" />
                                  </div>
                                  <div className="calc-column-offset-35 left-padding-5">
                                    <p>Edit Application</p>
                                  </div>
                                  <div className="clear"/>
                                </button>

                                <div className="row-5">
                                  <hr />
                                </div>

                                {((window.location.pathname.startsWith('/organizations') || window.location.pathname.startsWith('/advisor')) && (this.state.selectedJob && this.state.selectedJob.postType !== 'Program')) && (
                                  <div>
                                    <button onClick={() => this.actionClicked('refer')} className="background-button full-width left-text cta-color row-15">
                                      <div className="fixed-column-35">
                                        <img src={referIconDark} alt="GC" className="image-20-fit" />
                                      </div>
                                      <div className="calc-column-offset-35 left-padding-5">
                                        <p>Refer to Employer</p>
                                      </div>
                                      <div className="clear"/>
                                    </button>

                                    <div className="row-5">
                                      <hr />
                                    </div>
                                  </div>
                                )}

                                <button onClick={() => this.actionClicked('message')} className="background-button full-width left-text cta-color row-15">
                                  <div className="fixed-column-35">
                                    <img src={emailIcon} alt="GC" className="image-20-fit" />
                                  </div>
                                  <div className="calc-column-offset-35 left-padding-5">
                                    <p>Send Message</p>
                                  </div>
                                  <div className="clear"/>
                                </button>
                                {/*
                                <div className="row-5">
                                  <hr />
                                </div>

                                <button onClick={() => this.exportInfo()} className="background-button full-width left-text cta-color row-15">
                                  <div className="fixed-column-30">
                                    <img src={reportingIconDark} alt="GC" className="image-20-fit" />
                                  </div>
                                  <div className="calc-column-offset-35 left-padding-5">
                                    <p>Export to CSV</p>
                                  </div>
                                  <div className="clear"/>
                                </button>*/}
                              </div>
                            </div>
                          </div>

                          {(this.state.showLayoutToggle) && (
                            <div className="min-width-100 max-width-310 bottom-margin-20">
                              <p>Toggle to Old Layout</p>
                              <div className="top-margin">
                                <Switch
                                  onChange={(change) => this.setState({ showModule: change })}
                                  checked={this.state.showModule}
                                  id="normal-switch"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="clear" />

                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              {(this.state.showLayoutToggle) && (
                <div className="width-70-percent top-margin-15 bottom-margin-15 center-horizontally">
                  <div className="row-10">
                  </div>
                  <p>Toggle to New Layout</p>
                  <div className="top-margin">
                    <Switch
                      onChange={(change) => this.setState({ showModule: change })}
                      checked={this.state.showModule}
                      id="normal-switch"
                    />
                  </div>
                </div>
              )}

              {(this.state.selectedJob && subPostType === "Track") && (
                <div className="width-70-percent vertical-margin-2-percent center-horizontally">
                  <div className="float-left white-background standard-border medium-shadow">
                    <SubCustomDropdown dropdownTitle="Select a Pathway" name={"track"} value={this.state.trackSelected} options={this.state.trackOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler} clearPadding={true} />
                  </div>
                  {/*
                  <div className="float-left right-padding white-background standard-border medium-shadow">
                    <div className="float-left right-padding-5 left-padding nowrap">
                      <div className="half-spacer"/><div className="mini-spacer"/><div className="mini-spacer"/><div className="mini-spacer"/>
                      <p className="description-text-color half-bold-text">Track</p>
                    </div>
                    <div className="float-left">
                      <select name="track" value={this.state.trackSelected} onChange={this.formChangeHandler} className="filter-select">
                        {this.state.trackOptions.map(value =>
                          <option key={value.key} value={value.name}>{value.name}</option>
                        )}
                      </select>
                    </div>
                    <div className="dropdown-arrow-container">
                      <img src={dropdownArrow} alt="Compass dropdown arrow icon"/>
                    </div>
                  </div>*/}
                  <div className="clear"/>
                </div>
              )}

              <div className="candidate-container">
                <div>
                  {(this.state.selectedApplication) ? (
                    <div>
                      <ProfileCard selectedApplication={this.state.selectedApplication} workPreferenceResults={this.state.workPreferenceResults} selectedJob={this.state.selectedJob} benchmark={this.state.benchmark} benchmarkOptions={this.state.benchmarkOptions} wpQuestions={this.state.wpQuestions} source={this.state.sourceName} trackBenchmark={this.state.trackBenchmark} matchIndex={this.state.matchIndex} activeOrg={this.state.org} accountCode={this.state.accountCode} />

                      {this.renderEditView()}
                    </div>
                  ) : (
                    <div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <Modal
           isOpen={this.state.modalIsOpen}
           onAfterOpen={this.afterOpenModal}
           onRequestClose={this.closeModal}
           className="modal"
           overlayClassName="modal-overlay"
           contentLabel="Example Modal"
         >

          {(this.state.showAssignScorers) && (
            <div key="assign-scorers" className="full-width padding-40">
              <div className="row-10">
                <p className="heading-text-2">Specify the Scorer to Assign</p>
              </div>

              <div className="row-10">
                <p>Share this link with the external scorers after they've been assigned:</p>
                <a href={window.location.protocol + "//" + window.location.host + "/organizations/" + this.state.org + "/postings/" + this.state.selectedApplication._id + "/scores"} target="_blank" rel="noopener noreferrer">{window.location.protocol + "//" + window.location.host + "/organizations/" + this.state.org + "/postings/" + this.state.selectedApplication._id + "/scores"}</a>
              </div>

              <div className="edit-profile-row">
                <label className="profile-label">Email<label className="error-color bold-text">*</label></label>
                <input className="text-field" type="text" placeholder="Email" name="scorerEmail" value={this.state.scorerEmail} onChange={this.formChangeHandler} />
              </div>
              <div className="edit-profile-row">
                <div className="container-left">
                  <label className="profile-label">First Name</label>
                  <input className="text-field" type="text" placeholder="First Name" name="scorerFirstName" value={this.state.scorerFirstName} onChange={this.formChangeHandler} />
                </div>
                <div className="container-right">
                  <label className="profile-label">Last Name</label>
                  <input className="text-field" type="text" placeholder="Last Name" name="scorerLastName" value={this.state.scorerLastName} onChange={this.formChangeHandler} />
                </div>
                <div className="clear"/>
              </div>

              <div className="edit-profile-row">
                <div className="container-left">
                  <label className="profile-label">Job Title</label>
                  <input className="text-field" type="text" placeholder="Job Title" name="scorerJobTitle" value={this.state.scorerJobTitle} onChange={this.formChangeHandler} />
                </div>
                <div className="container-right">
                  <label className="profile-label">Employer Name</label>
                  <input className="text-field" type="text" placeholder="Employer Name" name="scorerEmployerName" value={this.state.scorerEmployerName} onChange={this.formChangeHandler} />
                </div>
                <div className="clear"/>
              </div>

              <div className="row-10">
                <div className="float-left">
                  <button className="btn btn-squarish cta-background-color cta-border-color" onClick={() => this.addItem('scorer')}>Add Scorer</button>
                </div>
                <div className="clear" />
              </div>

              {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 row-5 error-color">{this.state.errorMessage}</p>}
              {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 row-5 cta-color">{this.state.successMessage}</p>}

              <div className="row-20">
                <hr />
              </div>

              {(this.state.scorers && this.state.scorers.length > 0) && (
                <div>
                  {this.state.scorers.map((value, optionIndex) =>
                    <div key={optionIndex} className="float-left">
                      <div className="close-button-container-1" >
                        <button className="background-button" onClick={() => this.removeTag('scorer', optionIndex)}>
                          <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                        </button>
                      </div>
                      <div className="float-left right-padding-5">
                        <div className="half-spacer" />
                        <div className="tag-container-inactive">
                          {(value.firstName) ? (
                            <p className="description-text-2">{value.email} - {value.firstName} {value.lastName}</p>
                          ) : (
                            <p className="description-text-2">{value.email}</p>
                          )}
                        </div>
                        <div className="half-spacer" />
                      </div>
                    </div>
                  )}
                  <div className="clear" />
                </div>
              )}

              <div className="row-10">
                <div className="float-left">
                  <button className="btn btn-primary cta-background-color cta-border-color" onClick={() => this.assign('scorer')}>Save Changes</button>
                </div>
                <div className="float-left left-padding">
                  <button className="btn btn-secondary" onClick={() => this.setState({ modalIsOpen: false })}>Cancel</button>
                </div>
                <div className="clear" />
              </div>
            </div>
          )}
          {(this.state.showAssignStaff) && (
            <div key="assign-staff" className="full-width padding-40">
              <div className="row-10">
                <p className="heading-text-2">Specify the Staff to Assign</p>
              </div>

              <div className="row-10">
                <div className="container-left">
                  <label className="profile-label">Staff Member</label>
                  <select name="staffMember" value={this.state.assignedStaff.firstName + ' ' + this.state.assignedStaff.lastName} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.staffMemberOptions.map(value =>
                      <option key={value.email} value={value.firstName + ' ' + value.lastName}>{value.firstName} {value.lastName}</option>
                    )}
                  </select>
                </div>
                <div className="container-right">
                  {(!this.state.onMobile) && (
                    <div>
                      <div className="spacer" /><div className="spacer" /><div className="spacer" /><div className="spacer" />
                      <div className="mini-spacer" /><div className="mini-spacer" />
                    </div>
                  )}

                  <button className="btn btn-squarish cta-background-color cta-border-color" onClick={() => this.addItem('staff')}>Add Staff Member</button>
                </div>
                <div className="clear" />
              </div>

              {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 row-5 error-color">{this.state.errorMessage}</p>}
              {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 row-5 cta-color">{this.state.successMessage}</p>}

              {(this.state.assignedStaff && this.state.assignedStaff.email) && (
                <div>
                  <div key={"staff"} className="float-left">
                    <div className="close-button-container-1" >
                      <button className="background-button" onClick={() => this.removeTag('staff', null)}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{this.state.assignedStaff.firstName} {this.state.assignedStaff.lastName}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>
                  </div>
                  <div className="clear" />
                </div>
              )}

              <div className="row-10">
                <button className="btn btn-primary cta-background-color cta-border-color" onClick={() => this.assign('staff')}>Save Changes</button>
              </div>
            </div>
          )}

          {(this.state.showEditView) && (
            <div key="showEditView" className="full-width padding-20">
              <p className="heading-text-2 row-10">Edit Application</p>
              {this.renderEditView(true)}
            </div>
          )}

          {(this.state.showMatchScore) && (
            <div key="showMatchScore" className="full-width padding-20">
              <div className="padding-20">
                <div className="calc-column-offset-20 right-padding">
                  <p className="heading-text-2 bottom-padding">{this.state.selectedApplication.firstName} {this.state.selectedApplication.lastName} is a {(subPostType === 'Track') ? this.state.selectedApplication.matches[this.props.matchIndex] : this.state.selectedApplication.match}% Match</p>
                </div>
                <div className="fixed-column-20 top-margin-5">
                  <button className="background-button" onClick={() => console.log('')}>
                    <img src={closeIcon} alt="GC" className="image-auto-20" />
                  </button>
                </div>
                <div className="clear" />

                <p className="description-text-2 top-padding-5">Match percentage compares candidate against a "benchmark" (i.e. ideal candidate). Benchmark allocations below:</p>
                <div className="spacer"/><div className="spacer"/>
                <div>
                  <div>

                    {this.renderAllocation()}

                    {(this.props.source === 'Employer|Edit') ? (
                      <div>
                        <hr className="clear-margin clear-padding cta-border-color" />
                        <div className="spacer" />
                        <div className="float-left full-width right-text">
                          <p className="heading-text-2 cta-color bold-text">{this.state.totalPercent}%</p>
                        </div>
                        <div className="clear" />
                        {(this.state.totalPercent !== 100) && (
                          <div className="full-width">
                            <p className="error-message right-text">Please adjust percentages to equal 100%</p>
                          </div>
                        )}
                      </div>
                    ):(
                      <div>

                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

         </Modal>
        </div>

    )
  }
}

export default withRouter(AdminApplicationDetail);
